import {
  AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit,
  Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ChangeDetectionStrategy
} from '@angular/core';
import { hazardTypes } from 'src/app/modals/hazard-data';
import { Observable, forkJoin, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { ImageEditorService } from 'src/app/services/image-editor/image-editor.service';
import { UploadConfirmationModalComponent, UploadConfirmationResult } from 'src/app/components/upload-confirmation-modal/upload-confirmation-modal.component';
import { ImageUploadEvent } from 'src/app/shared/components/image-upload/image-upload.component';
import { LanguageSupportService } from 'src/app/services/language-support.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { isNotEmptyArray } from 'src/app/utilities/utils';
import { IonContent, ModalController } from '@ionic/angular';
import { PickHazardComponent } from 'src/app/components/pick-hazard/pick-hazard.component';
import { PlrScreenComponent } from 'src/app/components/plr-screen/plr-screen.component';
import { PictogramLibraryComponent } from 'src/app/components/pictogram-library/pictogram-library.component';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { AppConstants, PickType, StorageKeys, appLanguageOptions } from 'src/app/utilities/constant';
import { ToastService } from 'src/app/services/toast.service';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { GraphService } from 'src/app/services/graph/graph.service';
import { SubSink } from 'subsink';
import { EventProvider } from 'src/app/services/event';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { ValueAccessor } from '@ionic/angular/directives/control-value-accessors/value-accessor';
import { InitialHazardMeasureComponent } from 'src/app/components/initial-hazard-measure/initial-hazard-measure.component';
import { UnsavedChangesService } from 'src/app/services/unsaved-changes.service';
import { NgSelectComponent } from '@ng-select/ng-select';


interface ConformityStatusValue {
  c_status_id: number;
  c_status: string;
}

interface ConformityStatusMap {
  [machineMode: string]: ConformityStatusValue;
}

interface HazardStep {
  isActive: boolean;
  isCurrent?: boolean;
  isPartial?: boolean;
  title: string;
  name: string;
  val: string;
  isdone: boolean;
  isSelected: boolean;
}

type HazardLeaveContext = 'exit' | 'route' | 'logout';

@Component({
  selector: 'app-add-hazard',
  templateUrl: './add-hazard.page.html',
  styleUrls: ['./add-hazard.page.scss'],
})

export class AddHazardPage implements OnInit, AfterViewInit, OnDestroy {
  public hazardSteps: HazardStep[] = [
    { isActive: true, title: 'Hazard Images', name: 'Hazard Images', val: 'hi', isdone: false, isSelected: true }, 
    { isActive: false, title: 'Hazard Details', name: 'Hazard Details', val: 'hd', isdone: false, isSelected: false, },
    { isActive: false, title: 'Initial Hazard Rating Number (I-HRN)', name: 'Initial Hazard Rating Number (I-HRN)', val: 'chr', isdone: false, isSelected: false },
    { isActive: false, title: 'Measures', name: 'Initial Hazard and Measures', val: 'hch', isdone: false, isSelected: false },
    { isActive: false, title: 'Residual Hazard Rating Number (R-HRN)', name: 'Residual Hazard Rating Number (R-HRN)', val: 'hrn', isdone: false, isSelected: false },
  ];
  private originalHazardSteps: HazardStep[] = JSON.parse(JSON.stringify(this.hazardSteps));
  @Input() showHazardDetails: boolean = false;
  @Input() sections: any;
  @Input() selLanguage : string;
  @Input() hazardInfo : any;
  @Input() roadmapId: string;
  @Input() stepId: string;
  @Input() version: string;
  @Input() hazardId: string = '';
  @Output() exitHazardDetails = new EventEmitter<string>();
  @Input() machineModes: any;
  @ViewChild('addHazardDetails') form: NgForm;
  @ViewChild(InitialHazardMeasureComponent) initialHazardMeasureComponent: InitialHazardMeasureComponent;
  @Input() isReadonlyHazard: boolean = false;
  
  // Breadcrumb inputs
  @Input() breadcrumbSectionName: string = '';
  @Input() breadcrumbSubSectionName: string = '';
  @Input() breadcrumbStepName: string = '';
  public selectedHazardStep: string = 'Hazard Images';
  
  disableField: boolean = false;
  hardDetailsData: any = {};
  hazardTypeList = hazardTypes;
  translatedHazardTypeList: any[] = [];
  hazardSourceList = [];
  translatedHazardSourceList: any[] = [];
  hazardConsequencesList = [];
  translatedHazardConsequencesList: any[] = [];
  translatedMachineModeList: any[] = [];
  reviewImageSrc: string | ArrayBuffer;
  previewHazardFile: any[] = [];
  imageFiles: File[];
  addNewHazardDetails: any[] = [{}];
  gethazardTypeListLoading: boolean;
  gethazardSourceListLoading: boolean;
  gethazardConsequencesListLoading: boolean;
  isIncludeCategoryChecked = false;
  recommendedCategoryValue: any;
  measurePlrObj: any
  hazardImagesList = [];
  hazardImagesRes: any[] = [];
  editingImageIndex: number | null = null;
  get isEditingImage(): boolean {
    return this.editingImageIndex !== null;
  }
  selectedLanguage: string = this.languageSupportService.getDefaultLanguage();
  machineModeList: any[] = [];
  riskReMachineModeList = [{ value: 'Normal' }, { value: 'Setup' }, { value: 'Maintenance' }, { value: 'Other' }];
  hazardRatingList = [
    {
      listName: 'Probability of Occurrence', 
      listNameView: '', // This will be set in updateLanguage method
      weightagesList: [], // This will be set in updateLanguage method
      dataChrn: {}, 
      dataRiskChrn: {}, 
      dataRiskIhrn: {}, 
      dataIhrn: {}, 
      rating: '',
      val: 'PO'
    },
    {
      listName: 'Frequency of Exposition',
      listNameView: '', 
      weightagesList: [], 
      dataChrn: {}, 
      dataRiskChrn: {}, 
      dataRiskIhrn: {}, 
      dataIhrn: {}, 
      rating: '',
      val: 'FE'
    },
    {
      listName: 'Degree of Severity',
      listNameView: '', 
      weightagesList: [], 
      dataChrn: {}, 
      dataRiskChrn: {}, 
      dataRiskIhrn: {}, 
      dataIhrn: {}, 
      rating: '',
      val: 'SD'
    },
    {
      listName: 'Number of Persons Exposed',
      listNameView: '', 
      weightagesList: [], 
      dataChrn: {}, 
      dataRiskChrn: {}, 
      dataRiskIhrn: {}, 
      dataIhrn: {}, 
      rating: '',
      val : 'NP'
    }
  ];
  machineModeLists = [];
  public conformityStatus: ConformityStatusMap = {};
  getMachineModesLoading: boolean;
  sectionData: any;
  pickCntrlMeasureValue: any;
  pickInitialHazardValue: any;
  imageSrc: string | ArrayBuffer;
  hazardData: any;
  roadmapStatus = 'In-progress';
  isRiskReassessment = false;
  public isCustom = 'false';
  isEditingFourEyeQuality = false;
  machineModeWithIdsLists: any;
  riskMachineModesWithIds: any;
  addNewHazard: boolean;
  riskResassessmentmachineModeLists: any[];
  hazardSourceConnsequencesData: any[];
  @Input() serviceMachineId: string;
  projectId: any;
  machineId: any;
  serviceId: any;
  selectedMachineName: string;
  public selectedStep = 'hi';
  public subs = new SubSink();
  private isNewHazard = false;
  hazardDropdowndata: any[] = [];
  selectedHazardTypeId: string = '';
  hazardSources: any[] = [];
  hazardConsequences: any[] = [];
  selectedHazardSourceIds: string[] = [];
  selectedHazardConsequenceIds: string[] = [];
  selectedHazardSourceName: any[] = [];
  selectedHazardConsequenceName: any[] = [];
  selectedHazardTypeName: any | null = null;
  selectedHazardConsequenceId: string = '';
  selectedHazardLocation: string = '';
  hazardLocationItems: string[] = [];
  filteredHazardLocationItems: string[] = [];
  hazardLocationLoading = false;
  showHazardLocationSuggestions = false;
  activeHazardLocationOptionIndex = -1;
  showWhitespaceOnlyHazardLocationError = false;
  showHazardLocationLimitError = false;
  public readonly hazardLocationMaxLength = 500;
  private hazardLocationSearchTimer: any;
  private hazardLocationCurrentSearch: string = '';
  private hazardLocationCurrentSkip: number = 0;
  private readonly hazardLocationPageSize: number = 20;
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild('hazardContentScroll') hazardContentScroll: ElementRef<HTMLDivElement>;
    @ViewChildren('hazardRatingDropdown') hazardRatingDropdowns: QueryList<NgSelectComponent>;
  selectedMeasureType: any;
  remainingChars = 100;
  currentLength = 0;
  isOverMaxLength = false;
  readonly MAX_LENGTH = 101;
  public defaultInitialHazardLength = 1500;
  remainingInitialHazardChars = 1500;
  currentInitialHazardLength = 0;
  isInitialHazardOverMaxLength = false;
  readonly INITIAL_HAZARD_MAX_LENGTH = 1501;
  isNextEnableOnMeasureChange = true;
  showMeasureValidationErrors = false;
  isSaveAsDraft = false;
  private hasCompletedHazardSave = false;
  private initialHazardDirtySnapshot = '';
  private readonly unsavedChangesGuardHandler = (context?: string) =>
    this.confirmLeaveHazardWizard((context as HazardLeaveContext) || 'route');
  selectedMeasureIndex: number = -1;
  dynamicMeasures: any[] = [];
  hazardNamePattern: RegExp = /^[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N}\s._\-@#$%^&*()+={}\[\]|\\:;"'<>,.?/]*$/u;
  isHazardCopied: any;
  selectedModeValues: any = [];
  hazardViewOnlyImages: any[] = [];
  pictogramImages: any[] = [];
  groupedPictogramImages: { categoryId: string; categoryName: string; images: any[]; expanded: boolean }[] = [];
  private appLanguage: any;
  private machineDetails: any;
  private isSyncingHazardDropdownSelections = false;
  private pendingHazardSelectionSnapshot: {
    hazardTypeId: string | null;
    hazardTypeName: string | null;
    sourceIds: string[];
    sourceValues: string[];
    consequenceIds: string[];
    consequenceValues: string[];
  } | null = null;
  // Tracks the next order number to prevent duplicates during async uploads
  private pendingNextOrderNo: number = 0;
  private originalHazardImageNames = new Map<string, string>();
  private pendingImageDeletePayloads: any[] = [];
  public isCheckingPrimaryHazardImage = false;

  private normalizeHazardMediaItem(media: any): any {
    return {
      ...media,
      isView: media?.isView === true || media?.isView === 'true',
      isPrimary: media?.isPrimary === true || media?.isPrimary === 'true'
        || media?.is_primary === true || media?.is_primary === 'true'
        || media?.is_Primary === true || media?.is_Primary === 'true'
    };
  }

  private getHazardMediaPayload(): any[] {
    return (this.hazardImagesRes || []).filter((media: any) => !media?.isView).map((media: any) => ({
      ...media,
      isView: false,
      isPrimary: media?.isPrimary === true
    }));
  }

  private getUniqueHazardMediaItems(items: any[]): any[] {
    const seen = new Set<string>();
    return (items || []).filter((item, index) => {
      const key = String(item?.hazardMediaId || item?.id || item?.url || item?.fileName || item?.orderNo || index);
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  private getPersistedHazardMediaId(image: any): string {
    return this.normalizeHazardIdentifier(
      image?.hazardMediaId ?? image?.hazard_media_id ?? image?.id ?? image?.Id ?? image?.imageId ?? image?.image_id
    );
  }

  private async validatePersistedHazardImages(selectedImage?: any): Promise<boolean> {
    const hazardId = this.hazardId;
    const persistedImages = this.hazardImagesRes.filter(image =>
      (!selectedImage || image === selectedImage)
      && this.normalizeHazardIdentifier(image?.hazardMediaId) !== ''
    );
    if (!hazardId || !persistedImages.length) {
      return true;
    }

    try {
      const data = await this.backendService.getHazardDetails(hazardId);
      const media = data?.response?.hazardMedia;
      if (!data?.response || (media !== null && !Array.isArray(media))) {
        throw new Error('Invalid hazard media response');
      }
      if (this.hazardId !== hazardId) {
        return false;
      }

      const currentMedia: any[] = media || [];
      const deletedImages = new Set(persistedImages.filter(image => {
        const currentImage = currentMedia.find(current =>
          this.getPersistedHazardMediaId(current).trim().toLowerCase()
            === this.normalizeHazardIdentifier(image.hazardMediaId).trim().toLowerCase()
          || (image.url && current?.url
            && image.url.split(/[?#]/)[0] === current.url.split(/[?#]/)[0])
        );
        if (!currentImage) {
          return true;
        }

        const currentId = this.getPersistedHazardMediaId(currentImage);
        if (!currentId) {
          throw new Error('Missing persisted hazard media ID');
        }
        image.hazardMediaId = currentId;
        return false;
      }));
      if (!deletedImages.size) {
        return true;
      }

      this.hazardImagesRes = this.hazardImagesRes.filter(image => !deletedImages.has(image));
      this.updateHazardStepState();
      this.changeDetectorRef.detectChanges();
      this.toastService.presentToast(
        `${this.translate.instant('image')} ${this.translate.instant('has_been_deleted')}`,
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      return false;
    } catch (error) {
      console.error('Error validating hazard images:', error);
      this.toastService.presentToast(
        this.translate.instant('something_went_wrong'),
        4000,
        AppConstants.ERROR_SNACKBAR,
        'top'
      );
      return false;
    }
  }

  public async setPrimaryHazardImage(selectedItem: any): Promise<void> {
    if (!selectedItem || selectedItem.isView || this.isReadonlyHazard || this.isCheckingPrimaryHazardImage
      || !this.hazardImagesRes.includes(selectedItem)) {
      return;
    }

    this.isCheckingPrimaryHazardImage = true;
    try {
      if (!await this.validatePersistedHazardImages(selectedItem) || !this.hazardImagesRes.includes(selectedItem)) {
        return;
      }
      this.applyPrimaryHazardImage(selectedItem);
    } finally {
      this.isCheckingPrimaryHazardImage = false;
    }
  }

  private applyPrimaryHazardImage(selectedItem: any): void {
    const isUnselectingPrimary = selectedItem.isPrimary === true;
    this.allHazardImages.forEach((image: any) => {
      image.isPrimary = !isUnselectingPrimary && image === selectedItem;
    });

    this.hazardImagesRes = [...this.hazardImagesRes];
    this.hazardViewOnlyImages = [...this.hazardViewOnlyImages];
    this.updateHazardStepState();
    this.changeDetectorRef.detectChanges();
    this.toastService.presentToast(
      this.translate.instant('primary_image_updated'),
      4000,
      AppConstants.SUCCESS_SNACKBAR,
      'top'
    );
  }

  private getHazardImageIdentity(item: any, index: number): string {
    return String(item?.hazardMediaId || item?.url || item?.orderNo || index);
  }

  private queueImageDelete(payload: any): void {
    if (!payload?.id || this.pendingImageDeletePayloads.some(item => item.resourceType === payload.resourceType && item.id === payload.id)) {
      return;
    }

    this.pendingImageDeletePayloads.push(payload);
  }

  private flushPendingImageDeletes(): void {
    const payloads = [...this.pendingImageDeletePayloads];
    if (!payloads.length) {
      return;
    }

    this.pendingImageDeletePayloads = [];
    forkJoin(payloads.map(payload => this.backendService.deleteResource(payload))).subscribe({
      error: () => {
        this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      }
    });
  }

  cacheHazardImageOriginalName(item: any, index: number): void {
    if (item?.isView) {
      return;
    }
    const key = this.getHazardImageIdentity(item, index);
    this.originalHazardImageNames.set(key, item?.fileName || '');
  }

  validateHazardImageName(item: any, index: number): void {
    if (item?.isView) {
      return;
    }

    const key = this.getHazardImageIdentity(item, index);
    const originalName = this.originalHazardImageNames.get(key) ?? '';
    const normalizedCurrentName = (item?.fileName || '').trim().toLowerCase();

    if (!normalizedCurrentName) {
      return;
    }

    const editableImages = (this.allHazardImages || []).filter(img => !img?.isView);
    const hasDuplicateName = editableImages.some(img =>
      img !== item && (img?.fileName || '').trim().toLowerCase() === normalizedCurrentName
    );

    if (hasDuplicateName) {
      item.fileName = originalName;
      this.toastService.presentToast(this.translate.instant('image_name_already_exist'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      this.changeDetectorRef.detectChanges();
      return;
    }

    this.originalHazardImageNames.set(key, item?.fileName || '');
  }

  private normalizeHazardIdentifier(value: any): string {
    return value === null || value === undefined ? '' : String(value);
  }

  private normalizeHazardLocationValue(value: any): string {
    const rawValue = typeof value === 'string'
      ? value
      : value?.hazardLocation || value?.hazard_location || value?.location || value?.name || value?.value || value?.description || '';

    return this.normalizeHazardIdentifier(rawValue).substring(0, this.hazardLocationMaxLength);
  }

  private getHazardLocationCandidates(): string[] {
    const listCandidates = [
      this.hazardInfo?.hazardLocations,
      this.hazardInfo?.hazardLocationList,
      this.hazardInfo?.hazardLocationOptions,
      this.hazardInfo?.machineHazardLocations
    ];
    const values = [
      this.selectedHazardLocation,
      this.hazardInfo?.hazardLocation,
      this.hazardInfo?.hazard_location,
      this.hazardInfo?.location
    ];

    listCandidates.forEach((candidate) => {
      if (Array.isArray(candidate)) {
        candidate.forEach((item) => values.push(this.normalizeHazardLocationValue(item)));
      }
    });

    return values
      .map((item) => this.normalizeHazardLocationValue(item))
      .filter((item) => item.trim().length > 0);
  }

  private syncHazardLocationFromHazardInfo(): void {
    this.selectedHazardLocation = this.normalizeHazardLocationValue(
      this.hazardInfo?.hazardLocation || this.hazardInfo?.hazard_location || this.hazardInfo?.location || ''
    );
    this.setHazardLocationOnHazardInfo(this.selectedHazardLocation);
    this.refreshHazardLocationItems();
  }

  private refreshHazardLocationItems(search = ''): void {
    this.hazardLocationCurrentSearch = this.normalizeHazardLocationValue(search);
    this.hazardLocationCurrentSkip = 0;
    this.hazardLocationItems = [];
    this.filteredHazardLocationItems = [];
    this.fetchHazardLocations(this.hazardLocationCurrentSearch, 0);
  }

  private fetchHazardLocations(search: string, skip: number): void {
    this.hazardLocationLoading = true;
    const payload = {
      Search: search,
      Count: this.hazardLocationPageSize,
      Skip: skip,
      serviceMachineId: this.serviceMachineId
    };
    this.backendService.getHazardLocations(payload).subscribe(
      (res: any) => {
        this.hazardLocationLoading = false;
        const newItems: string[] = (res?.response || []).filter((item: any) => !!item);
        if (skip === 0) {
          this.hazardLocationItems = newItems;
        } else {
          this.hazardLocationItems = [...new Set([...this.hazardLocationItems, ...newItems])];
        }
        this.applyHazardLocationFilter();
      },
      (err) => {
        this.hazardLocationLoading = false;
        console.error('Error fetching hazard locations:', err);
      }
    );
  }

  public onHazardLocationScrollToEnd(): void {
    if (!this.hazardLocationLoading && this.hazardLocationItems.length % this.hazardLocationPageSize === 0 && this.hazardLocationItems.length > 0) {
      this.hazardLocationCurrentSkip += this.hazardLocationPageSize;
      this.fetchHazardLocations(this.hazardLocationCurrentSearch, this.hazardLocationCurrentSkip);
    }
  }

  onHazardLocationSuggestionScroll(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target || this.hazardLocationLoading) {
      return;
    }

    const distanceFromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
    if (distanceFromBottom <= 20) {
      this.onHazardLocationScrollToEnd();
    }
  }

  private getSanitizedHazardLocation(): string {
    const value = this.normalizeHazardLocationValue(this.selectedHazardLocation);
    return value.trim().length ? value.trim() : '';
  }

  private getHazardLocationForSave(): string {
    const value = this.getSanitizedHazardLocation();
    if (!value.length) {
      return '';
    }

    return this.shouldShowHazardLocationAddOption() ? '' : value;
  }

  private setHazardLocationOnHazardInfo(value: string): void {
    this.hazardInfo = this.hazardInfo || {};
    this.hazardInfo.hazardLocation = this.normalizeHazardLocationValue(value);
  }

  addHazardLocationTag = (term: string) => {
    const value = this.normalizeHazardLocationValue(term);
    return value.trim().length ? value : null;
  };

  onHazardLocationOpen(): void {
    if (this.isReadonlyHazard) {
      return;
    }

    this.showHazardLocationSuggestions = true;
    this.resetHazardLocationActiveOption();
    if (this.hazardLocationItems.length === 0) {
      this.refreshHazardLocationItems();
    } else {
      this.applyHazardLocationFilter();
    }
  }

  onHazardLocationSearch(term: string): void {
    clearTimeout(this.hazardLocationSearchTimer);
    const liveTerm = this.normalizeHazardLocationValue(term);
    this.hazardLocationSearchTimer = setTimeout(() => {
      this.refreshHazardLocationItems(liveTerm);
    }, 500);
  }

  onHazardLocationInput(event: any): void {
    const inputValue = this.normalizeHazardIdentifier(
      event?.detail?.value ?? event?.target?.value ?? this.selectedHazardLocation
    );
    this.onHazardLocationChanged(inputValue);
    this.syncHazardLocationInputValue(event, this.selectedHazardLocation);
    this.onHazardLocationSearch(this.selectedHazardLocation);
    this.showHazardLocationSuggestions = true;
    this.resetHazardLocationActiveOption();
  }

  onHazardLocationChanged(value: any): void {
    const beforeNormalize = String(value || '');
    this.selectedHazardLocation = this.normalizeHazardLocationValue(value);
    this.showWhitespaceOnlyHazardLocationError = this.selectedHazardLocation.length > 0 && !this.selectedHazardLocation.trim().length;
    // Show error only if value was truncated (exceeds 500 after normalization)
    this.showHazardLocationLimitError = beforeNormalize.length > this.hazardLocationMaxLength;
    this.setHazardLocationOnHazardInfo(this.selectedHazardLocation);

    this.applyHazardLocationFilter();
    this.updateHazardStepState();
  }

  onHazardLocationBlur(): void {
    setTimeout(() => {
      clearTimeout(this.hazardLocationSearchTimer);
      this.selectedHazardLocation = this.normalizeHazardLocationValue(this.selectedHazardLocation);
      this.showWhitespaceOnlyHazardLocationError = this.selectedHazardLocation.length > 0 && !this.selectedHazardLocation.trim().length;
      this.showHazardLocationLimitError = false;
      this.showHazardLocationSuggestions = false;
      this.resetHazardLocationActiveOption();
      this.setHazardLocationOnHazardInfo(this.selectedHazardLocation);
      this.updateHazardStepState();
    }, 150);
  }

  onHazardLocationKeydown(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }

    const inputElement = this.getHazardLocationTextareaElement(event);
    const currentValue = inputElement?.value || this.selectedHazardLocation || '';

    const navigationKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End', 'Tab', 'Escape', 'Control', 'Shift', 'Alt', 'Meta'
    ];

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (!this.showHazardLocationSuggestions) {
        this.showHazardLocationSuggestions = true;
        this.applyHazardLocationFilter();
      }

      const optionCount = this.getHazardLocationOptionCount();
      if (!optionCount) {
        return;
      }

      event.preventDefault();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      const nextIndex = this.getNextHazardLocationOptionIndex(direction, optionCount);
      this.setActiveHazardLocationOption(nextIndex);
      return;
    }

    if (event.key === 'Enter' && this.showHazardLocationSuggestions && this.activeHazardLocationOptionIndex >= 0) {
      event.preventDefault();
      this.selectActiveHazardLocationOption();
      return;
    }

    if (event.key === 'Tab') {
      this.showHazardLocationSuggestions = false;
      this.resetHazardLocationActiveOption();
      return;
    }

    if (event.key === 'Escape') {
      this.showHazardLocationSuggestions = false;
      this.resetHazardLocationActiveOption();
    }

    if (navigationKeys.includes(event.key)) {
      return;
    }

    const insertedValue = event.key === 'Enter' ? '\n' : event.key.length === 1 ? event.key : '';
    if (!insertedValue) {
      return;
    }

    if (insertedValue && !this.canInsertHazardLocationText(event, currentValue, insertedValue)) {
      event.preventDefault();
      event.stopPropagation();
      this.showHazardLocationLimitError = true;
    }
  }

  onHazardLocationBeforeInput(event: Event): void {
    const inputEvent = event as InputEvent;
    const inputType = inputEvent.inputType || '';
    if (!inputType.startsWith('insert') || inputType === 'insertFromPaste') {
      return;
    }

    const insertedValue = inputType === 'insertLineBreak' || inputType === 'insertParagraph'
      ? '\n'
      : inputEvent.data || '';
    if (!insertedValue) {
      return;
    }

    const inputElement = this.getHazardLocationTextareaElement(event);
    const currentValue = inputElement?.value || this.selectedHazardLocation || '';
    if (!this.canInsertHazardLocationText(event, currentValue, insertedValue)) {
      event.preventDefault();
      this.showHazardLocationLimitError = true;
    }
  }

  onHazardLocationPaste(event: Event): void {
    const clipboardEvent = event as ClipboardEvent;
    const pastedText = clipboardEvent.clipboardData?.getData('text') || '';
    if (!pastedText) {
      return;
    }

    const inputElement = this.getHazardLocationTextareaElement(event);
    const currentValue = inputElement?.value || this.selectedHazardLocation || '';
    const { selectionStart, selectionEnd } = this.getHazardLocationSelection(event, currentValue);
    const selectedLength = Math.max(0, selectionEnd - selectionStart);
    const availableLength = this.hazardLocationMaxLength - (currentValue.length - selectedLength);

    if (pastedText.length <= availableLength) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.showHazardLocationLimitError = true;

    if (availableLength <= 0) {
      return;
    }

    const allowedText = pastedText.substring(0, availableLength);
    const nextValue = `${currentValue.substring(0, selectionStart)}${allowedText}${currentValue.substring(selectionEnd)}`;
    this.selectedHazardLocation = this.normalizeHazardLocationValue(nextValue);
    this.syncHazardLocationInputValue(event, this.selectedHazardLocation);
    this.setHazardLocationOnHazardInfo(this.selectedHazardLocation);
    this.onHazardLocationSearch(this.selectedHazardLocation);
    this.applyHazardLocationFilter();

    const cursorPosition = selectionStart + allowedText.length;
    setTimeout(() => inputElement?.setSelectionRange(cursorPosition, cursorPosition));
  }

  private getHazardLocationTextareaElement(event: Event): HTMLTextAreaElement | null {
    const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const textareaFromPath = eventPath.find((element) => element instanceof HTMLTextAreaElement) as HTMLTextAreaElement | undefined;
    if (textareaFromPath) {
      return textareaFromPath;
    }

    const target = event.target as any;
    return target?.shadowRoot?.querySelector?.('textarea') || target?.querySelector?.('textarea') || null;
  }

  private getHazardLocationSelection(event: Event, currentValue: string): { selectionStart: number; selectionEnd: number } {
    const inputElement = this.getHazardLocationTextareaElement(event);
    const selectionStart = inputElement?.selectionStart ?? currentValue.length;
    const selectionEnd = inputElement?.selectionEnd ?? selectionStart;
    return { selectionStart, selectionEnd };
  }

  private canInsertHazardLocationText(event: Event, currentValue: string, insertedValue: string): boolean {
    const { selectionStart, selectionEnd } = this.getHazardLocationSelection(event, currentValue);
    const selectedLength = Math.max(0, selectionEnd - selectionStart);
    return currentValue.length - selectedLength + insertedValue.length <= this.hazardLocationMaxLength;
  }

  private syncHazardLocationInputValue(event: Event, value: string): void {
    const inputElement = this.getHazardLocationTextareaElement(event);
    if (inputElement && inputElement.value !== value) {
      inputElement.value = value;
    }

    const target = event.target as any;
    if (target && 'value' in target && target.value !== value) {
      target.value = value;
    }
  }

  onHazardLocationSuggestionSelected(value: string): void {
    this.selectedHazardLocation = this.normalizeHazardLocationValue(value);
    this.showWhitespaceOnlyHazardLocationError = false;
    this.showHazardLocationLimitError = false;
    this.showHazardLocationSuggestions = false;
    this.resetHazardLocationActiveOption();
    this.setHazardLocationOnHazardInfo(this.selectedHazardLocation);
    this.applyHazardLocationFilter();
    this.updateHazardStepState();
  }

  addCurrentHazardLocationAsNew(): void {
    const value = this.getSanitizedHazardLocation();
    if (!value.length) {
      this.showWhitespaceOnlyHazardLocationError = this.selectedHazardLocation.length > 0;
      return;
    }

    const exists = this.hazardLocationItems.some((item) => item?.trim().toLowerCase() === value.toLowerCase());
    if (!exists) {
      this.hazardLocationItems = [value, ...this.hazardLocationItems];
    }

    this.selectedHazardLocation = value;
    this.setHazardLocationOnHazardInfo(value);
    this.applyHazardLocationFilter();
    this.showHazardLocationSuggestions = false;
    this.resetHazardLocationActiveOption();
    this.updateHazardStepState();
  }

  getCurrentHazardLocationDraft(): string {
    return this.getSanitizedHazardLocation();
  }

  shouldShowHazardLocationAddOption(): boolean {
    const value = this.getSanitizedHazardLocation();
    if (!value.length) {
      return false;
    }

    return !this.hazardLocationItems.some((item) => item?.trim().toLowerCase() === value.toLowerCase());
  }

  isHazardLocationOptionActive(index: number): boolean {
    return this.activeHazardLocationOptionIndex === index;
  }

  private resetHazardLocationActiveOption(): void {
    this.activeHazardLocationOptionIndex = -1;
  }

  private getHazardLocationOptionCount(): number {
    return this.filteredHazardLocationItems.length + (this.shouldShowHazardLocationAddOption() ? 1 : 0);
  }

  private getNextHazardLocationOptionIndex(direction: number, optionCount: number): number {
    if (optionCount <= 0) {
      return -1;
    }

    if (this.activeHazardLocationOptionIndex < 0 || this.activeHazardLocationOptionIndex >= optionCount) {
      return direction > 0 ? 0 : optionCount - 1;
    }

    return (this.activeHazardLocationOptionIndex + direction + optionCount) % optionCount;
  }

  private setActiveHazardLocationOption(index: number): void {
    this.activeHazardLocationOptionIndex = index;
    setTimeout(() => {
      const activeOption = document.querySelector(`.hazard-location-option[data-option-index="${index}"]`) as HTMLElement | null;
      activeOption?.scrollIntoView({ block: 'nearest' });
    });
  }

  private selectActiveHazardLocationOption(): void {
    if (this.activeHazardLocationOptionIndex < 0) {
      return;
    }

    if (this.shouldShowHazardLocationAddOption()) {
      if (this.activeHazardLocationOptionIndex === 0) {
        this.addCurrentHazardLocationAsNew();
        return;
      }

      const itemIndex = this.activeHazardLocationOptionIndex - 1;
      const item = this.filteredHazardLocationItems[itemIndex];
      if (item != null) {
        this.onHazardLocationSuggestionSelected(item);
      }
      return;
    }

    const item = this.filteredHazardLocationItems[this.activeHazardLocationOptionIndex];
    if (item != null) {
      this.onHazardLocationSuggestionSelected(item);
    }
  }

  private applyHazardLocationFilter(): void {
    const term = (this.selectedHazardLocation || '').trim().toLowerCase();
    if (!term.length) {
      this.filteredHazardLocationItems = [...this.hazardLocationItems];
      this.resetHazardLocationActiveOption();
      return;
    }

    this.filteredHazardLocationItems = this.hazardLocationItems.filter((item) =>
      this.normalizeHazardIdentifier(item).toLowerCase().includes(term)
    );
    this.resetHazardLocationActiveOption();
  }

  /**
   * Returns editable images first, then view-only images.
   * Each group is sorted by backend-provided orderNo.
   */
  get allHazardImages(): any[] {
    const byBackendOrder = (a: any, b: any) => {
      const orderA = Number.isFinite(Number(a?.orderNo)) ? Number(a.orderNo) : Number.MAX_SAFE_INTEGER;
      const orderB = Number.isFinite(Number(b?.orderNo)) ? Number(b.orderNo) : Number.MAX_SAFE_INTEGER;
      return orderA - orderB;
    };

    const editableImages = [...(this.hazardImagesRes || [])].sort(byBackendOrder);
    const viewOnlyImages = [...(this.hazardViewOnlyImages || [])].sort(byBackendOrder);

    return [...editableImages, ...viewOnlyImages];
  }

  /**
   * TrackBy function for allHazardImages to prevent DOM re-creation on array changes
   */
  trackByImage(index: number, item: any): string {
    return item.url || index;
  }

  get allPictogramImages(): any[] {
    return [...this.pictogramImages].sort((a, b) => (a.orderNo || 0) - (b.orderNo || 0));
  }

  private rebuildGroupedPictogramImages(): void {
    const groups = new Map<string, { categoryId: string; categoryName: string; images: any[] }>();
    for (const img of this.allPictogramImages) {
      const catId = img.categoryId || 'uncategorized';
      if (!groups.has(catId)) {
        groups.set(catId, {
          categoryId: catId,
          categoryName: img.categoryName || 'Uncategorized',
          images: []
        });
      }
      groups.get(catId).images.push(img);
    }
    this.groupedPictogramImages = Array.from(groups.values()).map(g => ({ ...g, expanded: true }));
  }

  trackByPictogram(index: number, item: any): string {
    return item.pictogramImageId || item.url || index;
  }

  /**
   * Generates a random 4-digit number for image naming
   * @returns A random number between 1000 and 9999
   */
  private generateRandom4Digit(): number {
    return Math.floor(1000 + Math.random() * 9000);
  }

  /**
   * Gets the next available order number for new editable hazard images.
   * Returns sequential numbering: count of existing editable images + 1.
   * View-only images are intentionally ignored for this sequence.
   * Accounts for pending uploads to prevent concurrent collision.
   * @returns The next sequential order number for editable images.
   */
  private getNextAvailableOrderNo(): number {
    const editableImages = (this.hazardImagesRes || []).filter(img => !img?.isView);
    const nextSequential = editableImages.length + 1;
    
    // If there's a pending batch being uploaded, account for it to prevent concurrent collisions
    if (this.pendingNextOrderNo > 0) {
      return Math.max(nextSequential, this.pendingNextOrderNo + 1);
    }
    
    return nextSequential;
  }

  /**
   * Backfills orderNo from file name only when backend orderNo is missing/invalid.
   * Backend-provided orderNo is treated as source of truth.
   */
  private reassignOrderNoToExistingImages(): void {
    const allImages = [...this.hazardImagesRes, ...this.hazardViewOnlyImages];
    const imageNumberRegex = /_Image_(\d+)/i;
    
    allImages.forEach((img) => {
      const backendOrderNo = Number(img?.orderNo);
      if (Number.isFinite(backendOrderNo) && backendOrderNo > 0) {
        return;
      }

      if (img.fileName) {
        const match = img.fileName.match(imageNumberRegex);
        if (match) {
          img.orderNo = parseInt(match[1], 10);
        }
      }
    });
  }

  constructor(private translate: TranslateService,
    private languageSupportService: LanguageSupportService,
    public sharedValue: ShareValuesService,
    public modalController: ModalController,
    public userAuthService: UserAuthService,
    public backendService: BackendCallService,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private graphService: GraphService,
    private eventProvider: EventProvider,
    private confirmationService: ConfirmationService,
    private changeDetectorRef: ChangeDetectorRef,
    private imageEditorService: ImageEditorService,
    private unsavedChangesService: UnsavedChangesService,
  ) {
    this.route.queryParams.subscribe(async (params) => {
      this.selectedMachineName = params.selectedMachineName;
      this.projectId = params?.project_Id;
      this.machineId = params?.machineId;
      this.roadmapId = params?.roadmapId;
      this.serviceId = params?.serviceId;
      this.machineDetails = JSON.parse(params?.machineDetails);
    });
      this.appLanguage = this.languageSupportService.getDefaultLanguage();
  }

  /**
   * Updates char counter count
   * 
   * @param event 
   */
  public updateCharCount(event: any) {
    const value = event.target.value || '';
    this.currentLength = value.length;
    this.remainingChars = this.MAX_LENGTH - this.currentLength;
    this.isOverMaxLength = this.currentLength >= this.MAX_LENGTH;
    this.updateHazardStepState();
  }
  getDefaultHazardRatingList() {
    return [
      { listName: 'Probability of Occurrence', listNameView: '', weightagesList: [], dataChrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, dataIhrn: {}, rating: '', val: 'PO' },
      { listName: 'Frequency of Exposition', listNameView: '', weightagesList: [], dataChrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, dataIhrn: {}, rating: '', val: 'FE' },
      { listName: 'Degree of Severity', listNameView: '', weightagesList: [], dataChrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, dataIhrn: {}, rating: '', val: 'SD' },
      { listName: 'Number of Persons Exposed', listNameView: '', weightagesList: [], dataChrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, dataIhrn: {}, rating: '', val: 'NP' }
    ];
  }
  
  resetHazardRatingList() {
    this.hazardRatingList = this.getDefaultHazardRatingList();
  }
 /**
  * Updates hazard name character count
  */
 private updateHazardNameCharacterCount() {
    if (this.hazardInfo && this.hazardInfo.hazardName) {
      this.currentLength = this.hazardInfo.hazardName.length;
      this.remainingChars = this.MAX_LENGTH - this.currentLength;
    } else {
      this.currentLength = 0;
      this.remainingChars = this.MAX_LENGTH;
    }
  }

  public updateInitialHazardCharCount(event?) {
    const value = event ? event.target.value : this.hazardInfo.initialHazards.initial_hazard.length ? this.hazardInfo.initialHazards.initial_hazard : '';
    this.currentInitialHazardLength = value.length;
    this.remainingInitialHazardChars = this.INITIAL_HAZARD_MAX_LENGTH - this.currentInitialHazardLength;
    this.isInitialHazardOverMaxLength = this.currentInitialHazardLength >= this.INITIAL_HAZARD_MAX_LENGTH;
    this.updateHazardStepState();
  }

  private updateHazardDescriptionCharacterCount() {
    if (this.hazardInfo && this.hazardInfo?.initialHazards?.initial_hazard) {
      this.currentInitialHazardLength = this.hazardInfo?.initialHazards?.initial_hazard?.length;
      this.remainingInitialHazardChars = this.INITIAL_HAZARD_MAX_LENGTH - this.currentInitialHazardLength;
    } else {
      this.currentInitialHazardLength = 0;
      this.remainingInitialHazardChars = this.INITIAL_HAZARD_MAX_LENGTH;
    }
  }

  ngOnInit() {
    this.unsavedChangesService.registerGuard(this.unsavedChangesGuardHandler);
    this.sharedValue.getHazardDropdownData();
    this.sharedValue.getConformityStatus();
    this.subs.sink = this.sharedValue.hazardDropdownData$.subscribe((hazardDropdownData) => {
      const selectionSnapshot = this.getHazardSelectionSnapshot();
      this.translatedHazardTypeList = hazardDropdownData || [];

      if (!isNotEmptyArray(hazardDropdownData) || (!selectionSnapshot.hazardTypeId && !selectionSnapshot.hazardTypeName)) {
        return;
      }

      this.syncHazardDropdownSelections(hazardDropdownData);
      this.changeDetectorRef.detectChanges();
    });
  }
  ngAfterViewInit(): void {
  }

  closeHazardRatingDropdowns(): void {
    // Body-level panels must not stay behind when their scrollable fields move.
    this.hazardRatingDropdowns?.forEach(dropdown => {
      if (dropdown.isOpen) {
        dropdown.close();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsavedChangesService.clearGuard(this.unsavedChangesGuardHandler);
    this.subs.unsubscribe();
    clearTimeout(this.hazardLocationSearchTimer);
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBrowserRefresh(event: BeforeUnloadEvent): void {
    if (!this.shouldGuardUnsavedHazard()) {
      return;
    }

    event.preventDefault();
    event.returnValue = this.translate.instant('hazard_refresh_unsaved_changes_message');
  }

  public onSaveAsDraftChange(event: any): void {
    this.isSaveAsDraft = !!event?.detail?.checked;
    this.updateHazardStepState();
  }

  private getDraftStateFromHazardInfo(hazardInfo: any): boolean {
    const draftValues = [
      hazardInfo?.isDraft,
      hazardInfo?.is_draft,
      hazardInfo?.saveAsDraft,
      hazardInfo?.savedAsDraft,
      hazardInfo?.hazardDraft,
      hazardInfo?.isHazardDraft,
      hazardInfo?.draft
    ];

    if (draftValues.some(value => this.isTruthyDraftValue(value))) {
      return true;
    }

    const status = this.normalizeHazardIdentifier(
      hazardInfo?.status || hazardInfo?.hazardStatus || hazardInfo?.hazard_status || hazardInfo?.state
    ).trim().toLowerCase();

    return status === 'draft' || status === 'save as draft' || status === 'saved as draft';
  }

  private isTruthyDraftValue(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    if (typeof value === 'string') {
      const normalizedValue = value.trim().toLowerCase();
      return normalizedValue === 'true' || normalizedValue === '1' || normalizedValue === 'yes' || normalizedValue === 'draft';
    }

    return false;
  }

  private getHazardMachineModesFromHazardInfo(): any[] {
    const hazardRatingModes = this.hazardInfo?.hazardRatingnumber?.machineModes;
    const initialHazardModes = this.hazardInfo?.initialHazards?.machineModes;

    if (Array.isArray(hazardRatingModes) && hazardRatingModes.length > 0) {
      return hazardRatingModes;
    }

    return Array.isArray(initialHazardModes) ? initialHazardModes : [];
  }

  private shouldGuardUnsavedHazard(): boolean {
    return !this.isReadonlyHazard && !this.hasCompletedHazardSave && this.hasHazardUnsavedChanges();
  }

  private hasHazardUnsavedChanges(): boolean {
    const currentSnapshot = JSON.stringify(this.buildHazardDirtyStateSnapshot());

    if (!this.initialHazardDirtySnapshot) {
      this.initialHazardDirtySnapshot = currentSnapshot;
    }

    return currentSnapshot !== this.initialHazardDirtySnapshot;
  }

  private captureOriginalHazardState(): void {
    this.initialHazardDirtySnapshot = JSON.stringify(this.buildHazardDirtyStateSnapshot());
  }

  private buildHazardDirtyStateSnapshot(): any {
    return {
      hazardName: this.hazardInfo?.hazardName || '',
      hazardLocation: this.getSanitizedHazardLocation(),
      hazardTypeId: this.selectedHazardTypeId || this.hazardInfo?.hazardType?.id || this.hazardInfo?.hazardType?.hazardTypeId || '',
      hazardTypeName: this.selectedHazardTypeName?.hazardTypeName || this.hazardInfo?.hazardType?.hazardTypeName || '',
      sourceIds: [...(this.selectedHazardSourceIds || []), ...(this.hazardInfo?.hazardType?.hazardSources || []).map((item: any) => this.normalizeHazardIdentifier(item?.hazardSourceId || item?.id)).filter(Boolean)].sort(),
      consequenceIds: [...(this.selectedHazardConsequenceIds || []), ...(this.hazardInfo?.hazardType?.hazardConsequences || []).map((item: any) => this.normalizeHazardIdentifier(item?.hazardConsequenceId || item?.id)).filter(Boolean)].sort(),
      modeValues: this.getSelectedMachineModeValues().slice().sort(),
      initialHazard: this.hazardInfo?.initialHazards?.initial_hazard || '',
      controlMeasures: (this.dynamicMeasures || []).map((measure: any) => ({
        id: measure?.id || measure?.measureId || '',
        measure_type_id: measure?.measure_type_id,
        short_name: measure?.short_name || '',
        measure: measure?.measure || '',
        measure_text: measure?.measure_text || '',
        is_selected: measure?.is_selected,
        measurePlrObj: measure?.measurePlrObj ? JSON.parse(JSON.stringify(measure.measurePlrObj)) : null
      })),
      hazardMedia: (this.hazardImagesRes || []).map((media: any) => ({
        id: media?.id || '',
        url: media?.url || '',
        fileName: media?.fileName || '',
        orderNo: media?.orderNo,
        isView: media?.isView || false
      })),
      pictogramImages: (this.pictogramImages || []).map((image: any) => ({
        id: image?.id || '',
        url: image?.url || '',
        fileName: image?.fileName || '',
        categoryId: image?.categoryId || '',
        orderNo: image?.orderNo
      })),
      plrObj: this.hazardInfo?.plrObj ? JSON.parse(JSON.stringify(this.hazardInfo.plrObj)) : null,
      isSaveAsDraft: this.isSaveAsDraft
    };
  }

  private getHazardLeavePrompt(context: HazardLeaveContext): { title: string; message: string; discardText: string; showCancel: boolean } {
    if (context === 'logout') {
      return {
        title: this.translate.instant('are_you_sure_you_want_to_logout'),
        message: this.translate.instant('hazard_logout_unsaved_changes_message'),
        discardText: 'discard_and_logout',
        showCancel: true,
      };
    }

    if (context === 'route') {
      return {
        title: this.translate.instant('Are you sure you want to navigate away from this page ?'),
        message: this.translate.instant('Unsaved_Changes_Message'),
        discardText: 'navigate_without_saving',
        showCancel: true,
      };
    }

    return {
      title: this.translate.instant('Are you sure you want to exit?'),
      message: this.translate.instant('hazard_exit_unsaved_changes_message'),
      discardText: 'Exit',
      showCancel: false,
    };
  }

  private async confirmLeaveHazardWizard(context: HazardLeaveContext): Promise<boolean> {
    if (!this.shouldGuardUnsavedHazard()) {
      return true;
    }

    const prompt = this.getHazardLeavePrompt(context);
    const choice = await this.confirmationService.presentUnsavedChangesModal(
      prompt.title,
      prompt.message,
      {
        actionText: 'Save',
        discardText: prompt.discardText,
        showCancel: prompt.showCancel,
        useFullMessage: true,
      }
    );

    if (choice === 'save') {
      return this.saveHazardFromLeavePrompt();
    }

    if (choice === 'discard') {
      this.discardHazardWizard();
      return true;
    }

    return false;
  }

  private async saveHazardFromLeavePrompt(): Promise<boolean> {
    if (this.isSaveAsDraft) {
      return this.complete(this.form, true);
    }

    if (!this.validateHazardForStandardSave()) {
      return false;
    }

    return this.complete(this.form, false);
  }

  public onChangeMeasureType(item) {
    this.selectedMeasureType = item;
  }

  private scrollToBottom(): void {
    setTimeout(() => {
      const scrollDiv = this.hazardContentScroll?.nativeElement;
      if (scrollDiv) {
        scrollDiv.scrollTop = scrollDiv.scrollHeight;
      }
    }, 0);
  }

  private syncHazardDropdownSelections(hazardDropdownData: any[]): void {
    const selectionSnapshot = this.pendingHazardSelectionSnapshot || this.getHazardSelectionSnapshot();
    const selectedType = hazardDropdownData.find((item) =>
      this.normalizeHazardIdentifier(item.hazardTypeId) === this.normalizeHazardIdentifier(selectionSnapshot.hazardTypeId) ||
      item.hazardTypeName === selectionSnapshot.hazardTypeName
    );

    if (!selectedType) {
      return;
    }

    this.isSyncingHazardDropdownSelections = true;
    this.selectedHazardTypeId = this.normalizeHazardIdentifier(selectedType.hazardTypeId);
    this.selectedHazardTypeName = selectedType;
    this.hazardSources = selectedType.hazardSources || [];
    this.hazardConsequences = selectedType.hazardConsequences || [];

    const selectedSourceIds = selectionSnapshot.sourceIds;
    const selectedSourceValues = selectionSnapshot.sourceValues;
    this.selectedHazardSourceIds = this.hazardSources
      .filter((item) => selectedSourceIds.includes(this.normalizeHazardIdentifier(item.hazardSourceId)) || selectedSourceValues.includes(item.source))
      .map((item) => this.normalizeHazardIdentifier(item.hazardSourceId));
    this.selectedHazardSourceName = this.hazardSources.filter((item) =>
      selectedSourceIds.includes(this.normalizeHazardIdentifier(item.hazardSourceId)) || selectedSourceValues.includes(item.source)
    );

    const selectedConsequenceIds = selectionSnapshot.consequenceIds;
    const selectedConsequenceValues = selectionSnapshot.consequenceValues;
    this.selectedHazardConsequenceIds = this.hazardConsequences
      .filter((item) => selectedConsequenceIds.includes(this.normalizeHazardIdentifier(item.hazardConsequenceId)) || selectedConsequenceValues.includes(item.consequence))
      .map((item) => this.normalizeHazardIdentifier(item.hazardConsequenceId));
    this.selectedHazardConsequenceName = this.hazardConsequences.filter((item) =>
      selectedConsequenceIds.includes(this.normalizeHazardIdentifier(item.hazardConsequenceId)) || selectedConsequenceValues.includes(item.consequence)
    );
    this.pendingHazardSelectionSnapshot = null;
    this.updateHazardStepState();

    queueMicrotask(() => {
      this.isSyncingHazardDropdownSelections = false;
    });
  }

  private getHazardSelectionSnapshot(): {
    hazardTypeId: string | null;
    hazardTypeName: string | null;
    sourceIds: string[];
    sourceValues: string[];
    consequenceIds: string[];
    consequenceValues: string[];
  } {
    const selectedType = this.selectedHazardTypeName as any;
    const selectedSourceIds = Array.isArray(this.selectedHazardSourceIds) ? this.selectedHazardSourceIds : [];
    const selectedConsequenceIds = Array.isArray(this.selectedHazardConsequenceIds) ? this.selectedHazardConsequenceIds : [];
    const selectedSources = Array.isArray(this.selectedHazardSourceName) ? this.selectedHazardSourceName : [];
    const selectedConsequences = Array.isArray(this.selectedHazardConsequenceName) ? this.selectedHazardConsequenceName : [];

    return {
      hazardTypeId: this.normalizeHazardIdentifier(this.selectedHazardTypeId || selectedType?.hazardTypeId || this.hazardInfo?.hazardType?.id || this.hazardInfo?.hazardType?.hazardTypeId) || null,
      hazardTypeName: selectedType?.hazardTypeName || this.hazardInfo?.hazardType?.hazardTypeName || null,
      sourceIds: [
        ...selectedSourceIds.map((item) => this.normalizeHazardIdentifier(item)).filter(Boolean),
        ...selectedSources.map((item) => this.normalizeHazardIdentifier(item?.hazardSourceId || item?.id)).filter(Boolean),
        ...(this.hazardInfo?.hazardType?.hazardSources || []).map((item) => this.normalizeHazardIdentifier(item?.hazardSourceId || item?.id)).filter(Boolean)
      ],
      sourceValues: selectedSources.map((item) => item?.source || item?.value).filter(Boolean),
      consequenceIds: [
        ...selectedConsequenceIds.map((item) => this.normalizeHazardIdentifier(item)).filter(Boolean),
        ...selectedConsequences.map((item) => this.normalizeHazardIdentifier(item?.hazardConsequenceId || item?.id)).filter(Boolean),
        ...(this.hazardInfo?.hazardType?.hazardConsequences || []).map((item) => this.normalizeHazardIdentifier(item?.hazardConsequenceId || item?.id)).filter(Boolean)
      ],
      consequenceValues: selectedConsequences.map((item) => item?.consequence || item?.value || item?.consequences).filter(Boolean),
    };
  }

  private getSelectedHazardType(): any | null {
    if (this.selectedHazardTypeName?.hazardTypeId) {
      return this.translatedHazardTypeList.find((item) =>
        this.normalizeHazardIdentifier(item.hazardTypeId) === this.normalizeHazardIdentifier(this.selectedHazardTypeName.hazardTypeId)
      ) || this.selectedHazardTypeName;
    }

    if (this.selectedHazardTypeId) {
      return this.translatedHazardTypeList.find((item) =>
        this.normalizeHazardIdentifier(item.hazardTypeId) === this.normalizeHazardIdentifier(this.selectedHazardTypeId)
      ) || null;
    }

    return null;
  }

  private getSelectedHazardSources(): any[] {
    return this.hazardSources.filter((item) =>
      this.selectedHazardSourceIds.includes(this.normalizeHazardIdentifier(item.hazardSourceId))
    );
  }

  private getSelectedHazardConsequences(): any[] {
    return this.hazardConsequences.filter((item) =>
      this.selectedHazardConsequenceIds.includes(this.normalizeHazardIdentifier(item.hazardConsequenceId))
    );
  }

  getValueBasedOnCategory(category, val) {
    const mapping = {
      'PO': { '1': '0.033', '2': '0.5', '3': '1', '4': '2', '5': '5', '6': '8', '7': '10', '8': '15' },
      'SD': { '1': '0.1', '2': '0.5', '3': '1', '4': '2', '5': '4', '6': '8', '7': '12', '8': '15' },
      'FE': { '1': '0.5', '2': '1', '3': '1.5', '4': '2.5', '5': '4', '6': '5' },
      'NP': { '1': '1', '2': '2', '3': '4', '4': '8', '5': '12' }
    };
  
    return mapping[category]?.[val] || '';
  }  

  hrnDetails(hazardRatingList, hrnData, machineModesList) {
    
    const hazardTypes = {
      'Current': 'dataChrn',
      'Indicative': 'dataIhrn',
      'Risk Reassessment Current': 'dataRiskChrn',
      'Risk Reassessment Indicative': 'dataRiskIhrn'
    };
    
    hrnData.forEach(_hrn => {
      const targetKey = hazardTypes[_hrn.hrnType];      
      
        hazardRatingList.forEach(_hr => {
          const val = _hrn[_hr.val.toLowerCase()];
          // Drafts include empty HRN fields; leave their dropdowns unselected on reload.
          if (val === undefined || val === null || val === '' || !this.getValueBasedOnCategory(_hr.val, val)) {
            return;
          }
          const body = {
            label: '',
            value: this.getValueBasedOnCategory(_hr.val, val),
            id: val,
            rating: "0"
          };

          // Find matching weight for the value
          const matchedWeight = _hr.weightagesList.find(_wght => _wght.value === body.value);
          if (matchedWeight) {
            body.label = matchedWeight.label;
          }

          // Set the value for the specific machine mode
          if (!_hr[targetKey]) {
            _hr[targetKey] = {};
          }
          _hr[targetKey][_hrn.mode] = body;
        });
      });
    console.log('Updated HRN Settings',hazardRatingList);
  }
  
  updateLanguage(language: string): void {
    this.sharedValue.applyHazardRatingLanguage(this.hazardRatingList, language);
  }
  hrnData : any;
  ngOnChanges(changes: SimpleChanges): void {
    const hazardInfoChanged = !!changes['hazardInfo'];
    const languageChanged = !!changes['selLanguage'] && !changes['selLanguage'].firstChange;
    const currentSelectionSnapshot = this.getHazardSelectionSnapshot();

    if (hazardInfoChanged) {
      this.hasCompletedHazardSave = false;
      this.isSaveAsDraft = this.getDraftStateFromHazardInfo(changes['hazardInfo'].currentValue);
    }

    if(!this.dynamicMeasures.length) {
      this.isNextEnableOnMeasureChange = true;
    }
    if (hazardInfoChanged && !changes['hazardInfo'].firstChange) {
      this.updateHazardNameCharacterCount();
      this.updateHazardDescriptionCharacterCount();
    }

    if (changes['selLanguage']?.currentValue) {
      this.selectedLanguage = changes['selLanguage'].currentValue;
    }

    if (languageChanged) {
      const hasCurrentHazardSelection = !!currentSelectionSnapshot.hazardTypeId || !!currentSelectionSnapshot.hazardTypeName;
      this.pendingHazardSelectionSnapshot = hasCurrentHazardSelection ? currentSelectionSnapshot : null;
      this.updateLanguage(this.selectedLanguage);
      this.sharedValue.getHazardDropdownData();
      if (!hazardInfoChanged) {
        return;
      }
    }

    this.selectedHazardSourceIds = [];
    this.selectedHazardConsequenceIds = [];
    this.selectedHazardSourceName = [];
    this.selectedHazardConsequenceName = [];
    this.selectedHazardTypeId = '';
    this.selectedHazardTypeName = null;
    this.selectedHazardLocation = '';
    this.hazardLocationItems = [];
    this.showWhitespaceOnlyHazardLocationError = false;
    this.resetHazardRatingList();
    this.pendingNextOrderNo = 0; // Reset pending order number when hazard changes
    this.updateLanguage(this.selectedLanguage);
    this.selectedStep = 'hi';
    this.updateHazardStepState();
    this.getMachineModesList();
    this.pendingImageDeletePayloads = [];
    if(this.hazardInfo){
        if(this.hazardInfo?.hazardName) this.updateHazardNameCharacterCount();
      this.machineModeLists = this.getHazardMachineModesFromHazardInfo().map(mode => {
            const foundMode = this.machineModes?.find(item => item.id === mode.id);
            return {
                id: mode.id,
                value: foundMode?.mode_name || mode.value,
            label: foundMode?.name === 'Not Available'
              ? this.translate.instant('not_available')
              : (foundMode?.name || mode.value)
            };
        }).filter(mode => mode.value); // Filter out any modes that don't have a value
        const hazardMedia = (this.hazardInfo?.hazardMedia || []).map(media => this.normalizeHazardMediaItem(media));
        this.hazardImagesRes = this.getUniqueHazardMediaItems(hazardMedia.filter(media => !media.isView));
        this.hazardViewOnlyImages = this.getUniqueHazardMediaItems(hazardMedia.filter(media => media.isView));
        this.pictogramImages = (this.hazardInfo?.hazardPictogramMedia || this.hazardInfo?.pictogramHazardMedia || []).map(image => ({ ...image }));
        this.rebuildGroupedPictogramImages();
        // Re-assign sequential orderNo to existing images if they all have orderNo = 0
        this.reassignOrderNoToExistingImages();
        this.isHazardCopied = this.hazardInfo?.hazardMedia[0]?.isView;       
        this.recommendedCategoryValue = this.hazardInfo?.plrObj?.category;
        this.hrnData = this.hazardInfo?.hazardRatingnumber?.hazardRating || [];
        this.hrnData.filter(item => item.hrnType === 'Indicative').forEach(item => {
          const matchedStatus = this.sharedValue?.conformityStatus?.find(
            status => status.c_status_id === item.cStatusId
          );
          if (matchedStatus) {
            this.conformityStatus[item.mode] = matchedStatus;
          }
        });
        this.hrnDetails(this.hazardRatingList,this.hrnData,this.machineModeLists);
        this.syncHazardDropdownSelections(this.sharedValue.hazardDropdowndata);
        if(this.hazardInfo?.initialHazards?.initial_hazard.length) this.updateHazardDescriptionCharacterCount();
        this.syncHazardLocationFromHazardInfo();
        this.hazardInfo.initialHazards = this.hazardInfo?.initialHazards || {
          initial_hazard: this.hazardInfo?.initialHazards?.initial_hazard || '',
          machineModes: this.getHazardMachineModesFromHazardInfo()
        };
        this.dynamicMeasures = this.hazardInfo.controlMeasures || [];
        this.dynamicMeasures.forEach((measure) => {
          if (measure?.measure_type_id === 3 && !measure?.measurePlrObj) {
            measure.measurePlrObj = { isIncludeRecommandedCategory: true };
          }
        });
        // Checkbox reflects the actual value coming from the measure's measurePlrObj, not a value derived from plrObj/category.
        const plrMeasure = this.dynamicMeasures.find(measure => measure?.measure_type_id === 3);
        this.isIncludeCategoryChecked = plrMeasure?.measurePlrObj?.isIncludeRecommandedCategory !== false;
        this.captureOriginalHazardState();
    }
    else
    {
      this.hazardInfo = {};
      this.hazardInfo.hazardName = '';
      this.hazardInfo.hazardLocation = '';
      this.hazardInfo.initialHazard = '';
      this.hazardInfo.controlMeasure = '';
      this.hazardInfo.hazardType = {};
      this.hazardInfo.hazardType.hazardTypeName = '';
      this.hazardInfo.hazardType.hazardSources = [];
      this.hazardInfo.hazardType.hazardConsequences = [];
      this.machineModeLists = [];
      this.captureOriginalHazardState();
      this.hazardInfo.hazardRatingnumber = {};
      this.hazardInfo.hazardRatingnumber.machineModes = [];
      this.hazardInfo.hazardRatingnumber.hazardRating = [];
      this.currentLength = 0;
      this.remainingChars = this.MAX_LENGTH;
      this.hazardInfo.initialHazards = {
        initial_hazard: '',
        machineModes: []
      }
      this.hazardInfo.controlMeasures = [];
      this.selectedHazardLocation = '';
      this.hazardLocationItems = [];
      this.dynamicMeasures = [];
      this.pictogramImages = [];
      this.rebuildGroupedPictogramImages();
    }
   
    this.updateHazardStepState();
    this.resetScrollPosition();
  }

  public async handleFormAction() {
    if (this.isSaveAsDraft) {
      await this.complete(this.form, true);
      return;
    }

    if (!this.validateHazardForStandardSave()) {
      return;
    }

    await this.complete(this.form, false);
  }

  private validateHazardForStandardSave(showToast = true): boolean {
    if (this.initialHazardMeasureComponent) {
      this.handleMeasuresUpdate(this.initialHazardMeasureComponent.getMeasuresSnapshot());
    }

    // Only hazard name is required, all other fields are optional
    if (!this.hazardInfo.hazardName || this.hazardInfo.hazardName.trim() === '') {
      if (showToast) {
        this.toastService.presentToast(this.translate.instant('Hazard Name Required'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      }
      return false;
    }
    if (!this.hazardNamePattern.test(this.hazardInfo.hazardName)) {
      if (showToast) {
        this.toastService.presentToast(this.translate.instant('Hazard Name Invalid Start'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      }
      return false;
    }
    if (this.isOverMaxLength) {
      if (showToast) {
        this.toastService.presentToast(this.translate.instant('Hazard Name Max Length'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      }
      return false;
    }
    if (this.hasIncompleteMeasure()) {
      this.showMeasureValidationErrors = true;
      this.updateHazardStepState();
      if (showToast) {
        this.toastService.presentToast(this.translate.instant('measure_required_details'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      }
      return false;
    }
    if (this.hasWhitespaceOnlyMeasureNames()) {
      this.showMeasureValidationErrors = true;
      if (showToast) {
        this.toastService.presentToast(this.translate.instant('check_measure_names_only_spaces_not_allowed'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      }
      return false;
    }
    // Check for duplicate hazard image file names
    if (this.hazardImagesRes?.length > 0) {
      const hasEmptyHazardName = this.hazardImagesRes.some(img => !img.fileName || !img.fileName.trim());
      if (hasEmptyHazardName) {
        if (showToast) {
          this.toastService.presentToast(this.translate.instant('image_name_cannot_be_empty_or_whitespace'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
        }
        return false;
      }
      const hazardFileNames = this.hazardImagesRes.map(img => img.fileName?.trim().toLowerCase());
      const hasDuplicateHazardNames = hazardFileNames.some((name, index) => name && hazardFileNames.indexOf(name) !== index);
      if (hasDuplicateHazardNames) {
        if (showToast) {
          this.toastService.presentToast(this.translate.instant('duplicate_file_names'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
        }
        return false;
      }
    }
    // Check for duplicate pictogram image display names within the same category
    if (this.pictogramImages?.length > 0) {
      const hasEmptyPictogramName = this.pictogramImages.some(img => !img.displayName || !img.displayName.trim());
      if (hasEmptyPictogramName) {
        if (showToast) {
          this.toastService.presentToast(this.translate.instant('image_name_cannot_be_empty_or_whitespace'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
        }
        return false;
      }
      const hasDuplicatePictogramNames = this.pictogramImages.some((img, index) => {
        const name = img.displayName?.trim().toLowerCase();
        const categoryId = img.categoryId || 'uncategorized';
        return name && this.pictogramImages.some((other, otherIndex) =>
          otherIndex !== index &&
          other.displayName?.trim().toLowerCase() === name &&
          (other.categoryId || 'uncategorized') === categoryId
        );
      });
      if (hasDuplicatePictogramNames) {
        if (showToast) {
          this.toastService.presentToast(this.translate.instant('duplicate_pictogram_file_names'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
        }
        return false;
      }
    }

    const incompleteStep = this.getFirstIncompleteStartedStepForStandardSave();
    if (incompleteStep) {
      this.showMeasureValidationErrors = incompleteStep.val === 'hch';
      this.updateHazardStepState();
      this.form?.form?.markAllAsTouched();
      if (showToast) {
        this.presentIncompleteSaveToast(incompleteStep.val);
      }
      return false;
    }

    return true;
  }

  private getFirstIncompleteStartedStepForStandardSave(): HazardStep | null {
    return this.hazardSteps.find(step =>
      step.val !== 'hi' &&
      this.isHazardStepPartial(step.val) &&
      !this.isHazardStepComplete(step.val)
    ) || null;
  }

  private presentIncompleteSaveToast(stepValue: string): void {
    let messageKey = 'one_or_more_fields_missing_validation';

    if (stepValue === 'hi') {
      const hazardName = this.hazardInfo?.hazardName || '';
      messageKey = !hazardName.trim()
        ? 'Hazard Name Required'
        : hazardName.length > 100
          ? 'Hazard Name Max Length'
          : 'Hazard Name Invalid Start';
    }
     else if (stepValue === 'hd') {
      messageKey = 'hazard_details_fill_all_fields';
    } else if (stepValue === 'chr') {
      messageKey = 'initial_hrn_fill_all_fields';
    } else if (stepValue === 'hch') {
      messageKey = this.hasWhitespaceOnlyMeasureNames()
        ? 'check_measure_names_only_spaces_not_allowed'
        : 'measure_required_details';
    } else if (stepValue === 'hrn') {
      messageKey = 'one_or_more_fields_missing_validation';
    }

    this.toastService.presentToast(this.translate.instant(messageKey), 4000, AppConstants.WARNING_SNACKBAR, 'top');
  }

  ionViewWillEnter() {
    if (!this.isEditingFourEyeQuality) { this.getMachineLimits(); }
    this.hazardTypeList.forEach((each: any) => {
      each.isDisabled = false;
    });
  }

  getMachineLimits() {
    this.machineModeLists = [];
    // this.sharedValue.machineModeLists = [];
    if (this.serviceMachineId) {
      this.backendService.getMachineLimits(this.serviceMachineId)
        .subscribe(
          (data: any) => {
            if (data && isNotEmptyArray(data.machineMode)) {
              this.hardDetailsData.machineMode = data.machineMode;
              data.machineMode.forEach(_mm => {
                this.machineModeLists.push(_mm.machineMode);
                // this.sharedValue.machineModeLists.push(_mm.machineMode)
              });
            }
          },
          (err) => {
            console.log('getting issue in fetching machine limits data :', err);
          }
        );
    }
  }

  stepperChange(event: any, stepsList?: HazardStep[]) {
    const targetStep = event?.val;
    if (!targetStep || targetStep === this.selectedStep) {
      return;
    }

    if (!this.canNavigateToHazardStep(targetStep)) {
      setTimeout(() => {
        this.updateHazardStepState();
        this.changeDetectorRef.detectChanges();
      });
      return;
    }
   this.closeHazardRatingDropdowns();
    this.selectedStep = targetStep;
    if (targetStep === 'hrn') {
      this.ensureConformityStatusDefaults();
    }

    const targetIndex = this.getHazardStepIndex(targetStep);
    const measuresIndex = this.getHazardStepIndex('hch');
    if (targetIndex >= 0 && measuresIndex >= 0 && targetIndex < measuresIndex) {
      this.isNextEnableOnMeasureChange = true;
    }

    this.updateHazardStepState();
    this.resetScrollPosition();
  }

  private getHazardStepIndex(stepValue: string): number {
    return this.hazardSteps.findIndex(step => step.val === stepValue);
  }

  /**
   * Resets scroll position to top when navigating between steps.
   * ion-content has --overflow:hidden here; the real scroll container is .hazard-content.
   */
  private resetScrollPosition(): void {
    const scrollDiv = this.hazardContentScroll?.nativeElement;
    if (!scrollDiv) {
      return;
    }

    const scrollNow = () => { scrollDiv.scrollTop = 0; };

    scrollNow();
    this.changeDetectorRef.detectChanges();
    requestAnimationFrame(scrollNow);
    setTimeout(scrollNow, 50);
    setTimeout(scrollNow, 150);
    setTimeout(scrollNow, 300);
  }

  private canNavigateToHazardStep(targetStep: string): boolean {
    const targetIndex = this.getHazardStepIndex(targetStep);

    if (targetIndex <= 0) {
      return targetIndex === 0;
    }

    const blockingStep = this.getFirstIncompleteStepBefore(targetIndex);
    if (blockingStep) {
      this.presentIncompleteStepToast(blockingStep.val);
      this.updateHazardStepState();
      return false;
    }

    return true;
  }

  private getFirstIncompleteStepBefore(targetIndex: number): HazardStep | null {
    for (let index = 0; index < targetIndex; index++) {
      const step = this.hazardSteps[index];
      // Use navigation-specific validation (only mandatory fields)
      if (!this.isHazardStepRequiredForNavigation(step.val)) {
        return step;
      }
    }

    return null;
  }

  private presentIncompleteStepToast(stepValue: string): void {
    let messageKey = 'one_or_more_fields_missing_validation';

    if (stepValue === 'hi') {
      const hazardName = this.hazardInfo?.hazardName || '';
      messageKey = !hazardName.trim()
        ? 'Hazard Name Required'
        : hazardName.length > 100
          ? 'Hazard Name Max Length'
          : 'Hazard Name Invalid Start';
    } else if (stepValue === 'hd') {
      messageKey = 'hazard_details_fill_all_fields';
    } else if (stepValue === 'chr') {
      messageKey = 'initial_hrn_fill_all_fields';
    } else if (stepValue === 'hch') {
      this.showMeasureValidationErrors = true;
      messageKey = this.hasWhitespaceOnlyMeasureNames()
        ? 'check_measure_names_only_spaces_not_allowed'
        : 'measure_required_details';
    }

    this.toastService.presentToast(this.translate.instant(messageKey), 4000, AppConstants.WARNING_SNACKBAR, 'top');
  }

  changeHazardStep(direction: 'next' | 'back', stepValue?: string) {
    const currentIndex = this.hazardSteps.findIndex(step => step.val === stepValue);

    if (direction === 'next' && currentIndex < this.hazardSteps.length - 1) {
      // Only validate hazard name on the first step
      if (currentIndex === 0) {
        if (!this.hazardInfo.hazardName || this.hazardInfo.hazardName.trim() === '') {
          this.toastService.presentToast(this.translate.instant('Hazard Name Required'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
          return;
        }
        if (!this.hazardNamePattern.test(this.hazardInfo.hazardName)) {
          this.toastService.presentToast(this.translate.instant('Hazard Name Invalid Start'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
          return;
        }
        if (this.isOverMaxLength) {
          this.toastService.presentToast(this.translate.instant('Hazard Name Max Length'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
          return;
        }
      }

      // Validate hazard details on the second step (Hazard Details)
      if (currentIndex === 1) {
        const isMachineModeEmpty = !this.machineModeLists || this.machineModeLists.length === 0;
        const isHazardTypeEmpty = !this.selectedHazardTypeId;
        const isHazardSourceEmpty = !this.selectedHazardSourceIds || this.selectedHazardSourceIds.length === 0;
        const isHazardConsequenceEmpty = !this.selectedHazardConsequenceIds || this.selectedHazardConsequenceIds.length === 0;

        const isInitialHazardEmpty = !this.isInitialHazardComplete();

        if (isMachineModeEmpty || isHazardTypeEmpty || isHazardSourceEmpty || isHazardConsequenceEmpty  || isInitialHazardEmpty) {
          this.toastService.presentToast(
            this.translate.instant('hazard_details_fill_all_fields'),
            4000,
            AppConstants.WARNING_SNACKBAR,
            'top'
          );
          return;
        }
      }

      // Validate Initial Hazard Rating Number (I-HRN) on the third step
      if (currentIndex === 2) {
        if (!this.isCurrentHrnStepComplete()) {
          this.toastService.presentToast(
            this.translate.instant('initial_hrn_fill_all_fields'),
            4000,
            AppConstants.WARNING_SNACKBAR,
            'top'
          );
          return;
        }
      }

      if (currentIndex === 3) {
        if (this.initialHazardMeasureComponent) {
          this.handleMeasuresUpdate(this.initialHazardMeasureComponent.getMeasuresSnapshot());
        }

        if (!this.isHazardStepRequiredForNavigation('hch')) {
          this.presentIncompleteStepToast('hch');
          return;
        }
      }

      // Move to next step
      this.selectedStep = this.hazardSteps[currentIndex + 1].val;
      if (this.selectedStep === 'hrn') {
        this.ensureConformityStatusDefaults();
      }
    } else if (direction === 'back' && currentIndex > 0) {
      // Move to previous step
      this.selectedStep = this.hazardSteps[currentIndex - 1].val;
      this.isNextEnableOnMeasureChange = true;
    }

    this.updateHazardStepState();
    this.resetScrollPosition();

    // Update control measures if dynamic measures exist
    if (this.dynamicMeasures.length || this.hazardInfo?.controlMeasures?.length) {
      this.hazardInfo.controlMeasures = this.filterMeasuresForSelectedModes(
        this.dynamicMeasures.length ? this.dynamicMeasures : this.hazardInfo.controlMeasures
      );
      this.dynamicMeasures = this.hazardInfo.controlMeasures;
    }
  }

  private ensureConformityStatusDefaults(): void {
    if (!this.machineModeLists?.length) {
      return;
    }

    const applyDefaults = () => {
      const defaultConformityStatus = this.sharedValue?.conformityStatus?.find(
        (item: any) => item.c_status === 'Significant Residual Risk'
      );

      if (!defaultConformityStatus) {
        return;
      }

      this.machineModeLists.forEach((mode: any) => {
        const modeValue = mode?.value;
        if (!modeValue || this.conformityStatus[modeValue]?.c_status_id) {
          return;
        }

        const matchedHrn = this.hrnData?.find(
          hrn => hrn?.hrnType === 'Indicative' && hrn?.mode === modeValue && hrn?.cStatusId
        );

        if (matchedHrn?.cStatusId) {
          const matchedStatus = this.sharedValue?.conformityStatus?.find(
            (item: any) => item.c_status_id === matchedHrn.cStatusId
          );
          this.conformityStatus[modeValue] = matchedStatus || defaultConformityStatus;
          return;
        }

        this.conformityStatus[modeValue] = defaultConformityStatus;
      });

      this.updateHazardStepState();
      this.changeDetectorRef.detectChanges();
    };

    if (this.sharedValue?.conformityStatus?.length) {
      applyDefaults();
      return;
    }

    this.backendService.getConformityStatus().subscribe((data: any) => {
      if (data?.statusCode === 200 && Array.isArray(data.response)) {
        this.sharedValue.conformityStatus = data.response;
        applyDefaults();
      }
    });
  }

  isFieldEmpty(field: any): boolean {
    return field === undefined || Object.keys(field).length === 0;
  }

  private getTranslatedSource(sources): Observable<any[]> {
    const sourceObservables = sources?.map(item =>
      this.translate.get(item.source)
    );
    return forkJoin(sourceObservables).pipe(
      map(translations => {
        return sources?.map((item, index) => { return { ...item, source: translations[index] }; });
      })
    );
  }

 public getTranslationKey(status: string): string {
  if (!status) return '';

  // 1. Clean the incoming string from spaces/hidden characters
  const cleanStatus = status.trim().replace(/\s+/g, ' ');

  // 2. Exact match check for your existing legacy frontend keys (Case-Insensitive check)
  const lowerStatus = cleanStatus.toLowerCase();
  
  if (lowerStatus === 'not compliant') {
    return 'Not Compliant'; // Matches your old key exactly
  }
  
  if (lowerStatus === 'compliant risk after consideration of all applicable measures') {
    return 'Compliant risk after consideration of all applicable measures'; // Matches your old key exactly
  }

  // 3. Fallback for the remaining new keys (converts them into snake_case)
  return lowerStatus.replace(/\s+/g, '_');
}

  private getTranslatedMode(modes): Observable<any[]> {
    const modeObservables = modes?.map(item =>
      this.translate.get(item.value)
    );
    return forkJoin(modeObservables).pipe(
      map(translations => {
        return modes?.map((item, index) => ({
          value: item.value,
          label: translations[index]
        }));
      })
    );
  }

 public changeMode(ev: any): void {
  if (!Array.isArray(ev)) {
    return;
  }
  const previousModeValues = this.getSelectedMachineModeValues();
  this.conformityStatus = {};
  this.selectedModeValues = [];
  this.selectedModeValues = ev
    .map((ele: any) => this.getMachineModeValue(ele))
    .filter((modeValue: string) => modeValue.length > 0);
  const newlySelectedModes = ev.filter((mode: any) => {
    const modeValue = this.getMachineModeValue(mode);
    return modeValue && !previousModeValues.includes(modeValue);
  });
  this.machineModeLists = [...ev];
  if (this.hazardInfo?.controlMeasures?.length) {
    this.hazardInfo.controlMeasures = this.filterMeasuresForSelectedModes(this.hazardInfo.controlMeasures, newlySelectedModes);
  }
  this.dynamicMeasures = this.filterMeasuresForSelectedModes(this.dynamicMeasures, newlySelectedModes);
  if (this.initialHazardMeasureComponent) {
    this.initialHazardMeasureComponent.dynamicMeasures = this.filterMeasuresForSelectedModes(
      this.initialHazardMeasureComponent.dynamicMeasures,
      newlySelectedModes
    );
    this.initialHazardMeasureComponent.measuresUpdated.emit(this.initialHazardMeasureComponent.dynamicMeasures);
  }
  if (this.dynamicMeasures.length) {
    this.hazardInfo.controlMeasures = this.dynamicMeasures;
  }
  this.removeUnselectedMachineModeHrnData(this.selectedModeValues);
  ev.forEach((ele: any) => {
    const mode = ele.value;
    const matchedHrn = this.hrnData?.find(
      hrn => hrn?.hrnType === 'Indicative' &&
             hrn?.mode === mode
    );
    const defaultConformityStatus =
      this.sharedValue?.conformityStatus?.find(
        (item: any) => item.c_status === 'Significant Residual Risk'
      );
    this.conformityStatus[mode] = {
      c_status_id:
        matchedHrn?.cStatusId ??
        defaultConformityStatus?.c_status_id ??
        0,

      c_status:
        matchedHrn?.cStatus ??
        defaultConformityStatus?.c_status ??
        ''
    };
  });
  this.hazardRatingList.forEach(rating => {
    this.machineModeLists.forEach((mode: any) => {
      if (!rating.dataIhrn[mode.value]) {
        rating.dataIhrn[mode.value] = {};
      }
    });
  });
  this.updateHazardStepState();
  this.changeDetectorRef.detectChanges();
}

  private filterMeasuresForSelectedModes(measures: any[] = [], modesToAdd: any[] = []): any[] {
    const selectedModeValues = this.selectedModeValues.length ? this.selectedModeValues : this.getSelectedMachineModeValues();

    return (measures || [])
      .map(measure => {
        const measureModes = Array.isArray(measure?.machineModes)
          ? measure.machineModes
          : measure?.machineModes ? [measure.machineModes] : [];
        const retainedMachineModes = selectedModeValues.length
          ? measureModes.filter(mode => selectedModeValues.includes(this.getMachineModeValue(mode)))
          : [];

        modesToAdd.forEach(mode => {
          const modeValue = this.getMachineModeValue(mode);
          const shouldAddMode = modeValue &&
            selectedModeValues.includes(modeValue) &&
            !retainedMachineModes.some(retainedMode => this.getMachineModeValue(retainedMode) === modeValue);
          if (shouldAddMode) {
            retainedMachineModes.push(mode);
          }
        });

        return {
          ...measure,
          machineModes: retainedMachineModes
        };
      });
  }

  private removeUnselectedMachineModeHrnData(selectedModeValues: string[]): void {
    this.hazardRatingList.forEach(rating => {
      ['dataChrn', 'dataIhrn', 'dataRiskChrn', 'dataRiskIhrn'].forEach((dataKey) => {
        Object.keys(rating[dataKey] || {}).forEach(modeValue => {
          if (!selectedModeValues.includes(modeValue)) {
            delete rating[dataKey][modeValue];
          }
        });
      });
    });
  }

  compareModeObjects(item1: any, item2: any): boolean {
    return item1 && item2 ? item1.value === item2.value : item1 === item2;
  }

  compareHazardTypeObjects(item1: any, item2: any): boolean {
    return item1 && item2
      ? this.normalizeHazardIdentifier(item1.hazardTypeId) === this.normalizeHazardIdentifier(item2.hazardTypeId)
      : item1 === item2;
  }

  compareHazardSourceObjects(item1: any, item2: any): boolean {
    return item1 && item2
      ? this.normalizeHazardIdentifier(item1.hazardSourceId) === this.normalizeHazardIdentifier(item2.hazardSourceId)
      : item1 === item2;
  }

  compareHazardConsequenceObjects(item1: any, item2: any): boolean {
    return item1 && item2
      ? this.normalizeHazardIdentifier(item1.hazardConsequenceId) === this.normalizeHazardIdentifier(item2.hazardConsequenceId)
      : item1 === item2;
  }

  compareConformityStatus(item1: any, item2: any): boolean {
    return item1 && item2 ? item1.c_status_id === item2.c_status_id : item1 === item2;
  }

  public onConformityStatusChange(event: any, machineMode: string) {
    if (event) {
      this.conformityStatus[machineMode] = {
        c_status_id: event.c_status_id,
        c_status: event.c_status
      };
    }
    this.updateHazardStepState();
  }

  public updateIndicativeHRN(each, hazardRatingList, i) {
    each.dataIhrn = JSON.parse(JSON.stringify(each.dataChrn));
    this.updateHazardStepState();
  }

  public updateRiskIndicativeHRN(each, hazardRatingList, i) {
    each.dataRiskIhrn = JSON.parse(JSON.stringify(each.dataRiskChrn));
  }

  get chrnTotal() {    
    return this.calculateTotal('dataChrn');
  }
  
  get ihrnTotal() {
    return this.calculateTotal('dataIhrn');
  }

  get chrnRiskTotal() {
    return this.calculateTotal('dataRiskChrn');
  }

  get ihrnRiskTotal() {
    return this.calculateTotal('dataRiskIhrn');
  }

  calculateTotal(dataKey: 'dataChrn' | 'dataIhrn' | 'dataRiskChrn' | 'dataRiskIhrn') {
    return this.machineModeLists?.map((each) => {
      const ratings = this.hazardRatingList.map(rating => rating[dataKey]?.[each.value]);
      if (ratings.some(rating =>
        rating?.id === undefined || rating?.id === null || rating?.id === '' ||
        rating?.value === undefined || rating?.value === null || rating?.value === '' ||
        !Number.isFinite(Number(rating.value))
      )) {
        return 0;
      }

      const temp = ratings.reduce((total, rating) => total * Number(rating.value), 1);
      return temp >= 0.6 && temp <= 0.9 ? 1.0 : +temp.toFixed(2);
    });
  }

  async openPickHazardsList(event: { type: string, index?: number, measure?: any }) {
    // The picker ranks the library against this hazard; without the context it
    // falls back to the plain alphabetical list. The measure-type dropdown is
    // deliberately not sent: filtering to one type hides the measures higher in the
    // ISO 12100 hierarchy, which are the ones an assessor should see first.
    const props = {
      type: event?.type,
      measureType: event?.measure?.selectedMeasureType,
      suggestionContext: {
        hazard: this.hazardInfo?.initialHazards?.initial_hazard || '',
        machineName: this.selectedMachineName || '',
        stepName: [this.breadcrumbSectionName, this.breadcrumbSubSectionName, this.breadcrumbStepName]
          .filter(Boolean).join(' > '),
      },
      // Used only by the AI-recommended section. Ranking a library row against the
      // hazard category or its location on the machine adds nothing, but a measure
      // written from scratch names the part and cites the standard for that category.
      generationExtras: {
        hazardName: this.hazardInfo?.hazardName || '',
        hazardType: this.hazardInfo?.hazardType?.hazardTypeName || '',
        hazardLocation: this.hazardInfo?.hazardLocation || '',
        hazardSources: (this.hazardInfo?.hazardType?.hazardSources || [])
          .map((s) => s?.value).filter(Boolean).join(', '),
        hazardConsequences: (this.hazardInfo?.hazardType?.hazardConsequences || [])
          .map((c) => c?.value).filter(Boolean).join(', '),
      },
    };
    const modal = await this.modalController.create({
      component: PickHazardComponent,
      cssClass: 'pickhazard-alert-modal',
      backdropDismiss: false,
      componentProps: props,
      showBackdrop: false,
    });
    await modal.present();
    const result = await modal.onDidDismiss();
    if (result && result.data) {
      const selectedValue = result.data.selectedData.value;
      const selectedMeasureType = result.data.measureType;
      if (event.type === PickType.PICK_MEASURE && event.index !== undefined) {
        const measure = this.dynamicMeasures[event.index];
        measure.control_measure = selectedValue;
        if (selectedMeasureType) {
          measure.selectedMeasureType = selectedMeasureType;
          measure.measure_type_id = selectedMeasureType.measure_type_id;
          measure.measure_type_name = selectedMeasureType.measure_type_name
          if (selectedMeasureType.measure_type_id === 3) {
            measure.is_plr = true;
            const selectedMeasurePlr = result?.data?.selectedData?.measurePlrObj || result?.data?.selectedData?.plrObj || null;
            const existingMeasurePlr = event?.measure?.measurePlrObj || null;
            const sourceMeasurePlr = selectedMeasurePlr || existingMeasurePlr || {};
            const category = sourceMeasurePlr?.category || sourceMeasurePlr?.recommendedCategory || '';
            const isIncludeRecommandedCategory = typeof selectedMeasurePlr?.isIncludeRecommandedCategory === 'boolean'
              ? selectedMeasurePlr.isIncludeRecommandedCategory
              : typeof existingMeasurePlr?.isIncludeRecommandedCategory === 'boolean'
                ? existingMeasurePlr.isIncludeRecommandedCategory
                : true;
            measure.measurePlrObj = {
              plr: sourceMeasurePlr?.plr || '',
              sValue: sourceMeasurePlr?.sValue || '',
              pValue: sourceMeasurePlr?.pValue || '',
              fValue: sourceMeasurePlr?.fValue || '',
              category,
              recommendedCategory: sourceMeasurePlr?.recommendedCategory || category,
              isIncludeRecommandedCategory,
              plrDescription: sourceMeasurePlr?.plrDescription || '',
              isPlrFromGraph : sourceMeasurePlr?.isPlrFromGraph || false
            };
          } else {
            measure.is_plr = false;
            measure.measurePlrObj = null;
          }
        }
        this.pickCntrlMeasureValue = selectedValue;
        if (this.initialHazardMeasureComponent?.dynamicMeasures?.[event.index]) {
          Object.assign(this.initialHazardMeasureComponent.dynamicMeasures[event.index], measure);
        }
        this.handleMeasuresUpdate(this.dynamicMeasures);
        this.changeDetectorRef.detectChanges();
      } else {
        this.pickInitialHazardValue = selectedValue;
        this.hazardInfo.initialHazard = selectedValue;
        if (!this.hazardInfo.initialHazards) {
          this.hazardInfo.initialHazards = {
            initial_hazard: '',
            machineModes: this.hazardInfo.hazardRatingnumber?.machineModes || []
          };
        }
        this.hazardInfo.initialHazards.initial_hazard = selectedValue;
        this.updateInitialHazardCharCount();
      }
      this.changeDetectorRef.detectChanges();
    }
  }

  async determinePlr(event) {
    this.hazardInfo.plrObj = this.hazardInfo.plrObj || {};
    const props = { isCategoryIncluded: this.isIncludeCategoryChecked };
    props['plrObj'] = event?.measurePlrObj;
    props['category'] = event?.measurePlrObj?.category;
    const modal = await this.modalController.create({
      component: PlrScreenComponent,
      cssClass: 'plr-screen-class',
      backdropDismiss: false,
      componentProps: props,
      showBackdrop: false,
    });
    await modal.present();
    await modal.onDidDismiss().then((result) => {
      this.hazardInfo.plrObj = this.hazardInfo.plrObj || {};
      if (Object.keys(result?.data).length !== 0) {
        if (result.data.plr_value) {
          this.hazardInfo.plrObj.plr = result.data.plr_value;
          this.hazardInfo.plrObj.sValue = result.data.sValue;
          this.hazardInfo.plrObj.fValue = result.data.fValue;
          this.hazardInfo.plrObj.pValue = result.data.pValue;
          if (result.data.category_value) {
            this.recommendedCategoryValue = result.data.category_value;
            if (this.isIncludeCategoryChecked) { this.hazardInfo.plrObj.category = result.data.category_value; }
          }
          const isIncludeRecommandedCategory = event?.measurePlrObj?.isIncludeRecommandedCategory !== false;
          const category = this.recommendedCategoryValue;
          this.hazardInfo.plrObj.category = category;
          this.hazardInfo.plrObj.plrDescription = result.data.plrDescription;
          this.hazardInfo.plrObj.isPlrFromGraph  = result.data.isPlrFromGraph
          this.measurePlrObj = {
            ...this.hazardInfo.plrObj,
            category,
            recommendedCategory: this.recommendedCategoryValue,
            isIncludeRecommandedCategory,
            plrDescription: this.hazardInfo.plrObj.plrDescription,
            isPlrFromGraph : this.hazardInfo.plrObj.isPlrFromGraph
          };
          this.changeDetectorRef.detectChanges();
        }else {
          this.hazardInfo.plrObj.plr = result.data.plr_value;
          this.hazardInfo.plrObj.sValue = result.data.sValue;
          this.hazardInfo.plrObj.category = result.data.category;
          this.hazardInfo.plrObj.plrDescription = result.data.plrDescription;


          if (result.data.category) {
            this.recommendedCategoryValue = result.data.category;
            if (this.isIncludeCategoryChecked) { this.hazardInfo.plrObj.category = result.data.category; }
          }
          const isIncludeRecommandedCategory = event?.measurePlrObj?.isIncludeRecommandedCategory !== false;
          const category = this.recommendedCategoryValue;
          this.hazardInfo.plrObj.category = category;
          this.hazardInfo.plrObj.plrDescription = result.data.plrDescription;
          this.hazardInfo.plrObj.isPlrFromGraph  = result.data.isPlrFromGraph
           
          this.measurePlrObj = {
            ...this.hazardInfo.plrObj,
            category,
            recommendedCategory: this.recommendedCategoryValue,
            isIncludeRecommandedCategory,
            plrDescription: this.hazardInfo.plrObj.plrDescription,
            isPlrFromGraph : this.hazardInfo.plrObj.isPlrFromGraph
          };
          this.changeDetectorRef.detectChanges();
        
        }
      }
    });
  }

  controlMeasureAddToLibrary(event) {
    const userId = this.userAuthService.getUserList().userId;
    const measureValue = (event?.control_measure || '').trim();
    const measureTypeId = event?.measure_type_id || event?.selectedMeasureType?.measure_type_id;

    if (!measureValue || !measureTypeId) {
      return;
    }

    const payload = [
      {
        id: '',
        value: measureValue,
        measure_type_id: measureTypeId,
        languageCode: this.getDefaultAddLibraryLanguageCode(),
        userId
      }
    ];
    this.backendService.controlMeasureAddToLibrary(payload).subscribe((res: any) => {
      const controlMeasureResponse = res.value;
      const translatedMeausreMessage = this.translate.instant(AppConstants.CONTROL_MEASURE_EXISTS);
      const normalizedControlMeasureResponse = typeof controlMeasureResponse === 'string' ? controlMeasureResponse.trim().toLowerCase() : '';
      const translatedSuccessMessage = normalizedControlMeasureResponse === 'control measure added to the library successfully'
        ? this.translate.instant('Control measure added to the library successfully')
        : this.translate.instant(res?.value);
      controlMeasureResponse.includes("Error:")
        ? this.toastService.presentToast(translatedMeausreMessage, 4000, AppConstants.ERROR_SNACKBAR, AppConstants.TOP)
        : this.toastService.presentToast(translatedSuccessMessage, 4000, AppConstants.SUCCESS_SNACKBAR, AppConstants.TOP);
    }, err => {
      this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, AppConstants.TOP);
    });
  }

  initialMeasureAddToLibrary(pickInitialHazard) {
    const hazardText = (typeof pickInitialHazard === 'string' ? pickInitialHazard : '')
      || this.hazardInfo?.initialHazards?.initial_hazard
      || '';
    const initialHazardValue = hazardText.trim();

    if (!initialHazardValue) {
      return;
    }

    const userId = this.userAuthService.getUserList().userId;
    const payload = [
      {
        id: '',
        value: initialHazardValue,
        languageCode: this.getDefaultAddLibraryLanguageCode(),
        userId
      }
    ];
    this.backendService.initialMeasureAddToLibrary(payload).subscribe((res: any) => {
      const InitiaHazardResponse = res.value;
      this.hazardInfo.initialHazards = {
        initial_hazard: this.hazardInfo?.initialHazards?.initial_hazard,
        machineModes: this.hazardInfo.hazardRatingnumber.machineModes || []
      };
      const translatedHazardMessage = this.translate.instant(AppConstants.INITIAL_HAZARD_EXISTS);
      const normalizedHazardResponse = typeof InitiaHazardResponse === 'string' ? InitiaHazardResponse.trim().toLowerCase() : '';
      const successToastMessage = normalizedHazardResponse === 'initial hazard added to the library successfully'
        ? this.translate.instant('Initial Hazard added to the library successfully')
        : this.translate.instant(res?.value);
      InitiaHazardResponse.includes("Error:")
        ? this.toastService.presentToast(translatedHazardMessage, 4000, AppConstants.ERROR_SNACKBAR, AppConstants.TOP)
        : this.toastService.presentToast(successToastMessage, 4000, AppConstants.SUCCESS_SNACKBAR, AppConstants.TOP);
    }, err => {
      this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, AppConstants.TOP);
    });
  }

  /**
   * Resolves the language code for Add-to-Library based on the selected app language.
   * Normalises Spanish ('es' → 'sp') and falls back
   * to 'en' when the active code isn't supported.
   */
  private getDefaultAddLibraryLanguageCode(): string {
    const active = (this.selectedLanguage || this.selLanguage || this.translate.currentLang || this.translate.defaultLang || 'en').toLowerCase();
    const normalised = active === 'es' ? 'sp' : active;
    return appLanguageOptions.some(option => option.code === normalised) ? normalised : 'en';
  }

  addCategoryValue(event) {
    this.hazardInfo.plrObj.category = this.isIncludeCategoryChecked ? this.recommendedCategoryValue : '';
  }

  /**
   * Handler for files selected from the reusable image-upload component
   * (drag-drop, click, or paste). Routes through the upload confirmation popup.
   */
  public onMachineImagesSelected(event: ImageUploadEvent): void {
    const files: File[] = event?.files;
    if (!files || files.length === 0) {
      return;
    }
    this.inputHazardImg(files, {} as HTMLInputElement);
  }

  /** Maximum allowed image file size (bytes) — matches the app-image-upload component default. */
  private readonly MAX_HAZARD_IMAGE_SIZE = 5242880; // 5 MB

  public async inputHazardImg(files: File[], hazardImage: HTMLInputElement) {
    const imgFiles = Array.from(files);
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const hasInvalidFile = imgFiles.some(file => !allowedTypes.includes(file.type));
    if (hasInvalidFile) {
      this.toastService.presentToast(
        this.translate.instant(AppConstants.ONLY_IMAGE_FILES_ALLOWED),
        4000,
        AppConstants.ERROR_SNACKBAR,
        AppConstants.TOP
      );
      if (hazardImage?.value !== undefined) hazardImage.value = '';
      return;
    }

    const imageFiles = imgFiles.filter(file => file.type && file.type.startsWith('image/'));
    if (imageFiles.length === 0) {
      if (hazardImage?.value !== undefined) hazardImage.value = '';
      return;
    }

    // Validate filename constraints before opening upload confirmation popup.
    const hasInvalidImageName = imageFiles.some(file => !file?.name || file.name.trim().length === 0 || file.name.length > 100);
    if (hasInvalidImageName) {
      this.toastService.presentToast(
        this.translate.instant('image_name_validation'),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      if (hazardImage?.value !== undefined) hazardImage.value = '';
      return;
    }

    // Filter out files that exceed the size limit before showing the popup
    const validSizeFiles = imageFiles.filter(file => file.size <= this.MAX_HAZARD_IMAGE_SIZE);
    const oversizedCount = imageFiles.length - validSizeFiles.length;
    if (oversizedCount > 0) {
      const maxMB = (this.MAX_HAZARD_IMAGE_SIZE / (1024 * 1024)).toFixed(0);
      this.toastService.presentToast(
        this.translate.instant('image_size_exceeds_limit', { count: oversizedCount, max: maxMB }),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
    }

    if (validSizeFiles.length === 0) {
      if (hazardImage?.value !== undefined) hazardImage.value = '';
      return;
    }

    // Store valid files temporarily and show upload confirmation popup
    this.pendingHazardImageFiles = validSizeFiles;
    if (hazardImage?.value !== undefined) hazardImage.value = '';
    await this.showHazardUploadConfirmation();
  }

  /** Temporarily holds validated image files awaiting user confirmation. */
  private pendingHazardImageFiles: File[] = [];

  /**
   * Shows the upload confirmation popup. The user can choose to:
   * - Upload Directly: skip the editor and upload as-is.
   * - Edit Images: open the image editor first, then upload.
   * - Close (X): discard temporarily stored files.
   */
  private async showHazardUploadConfirmation(): Promise<void> {
    if (!this.pendingHazardImageFiles.length) {
      return;
    }

    const modal = await this.modalController.create({
      component: UploadConfirmationModalComponent,
      cssClass: 'upload-confirmation-modal',
      backdropDismiss: false,
      componentProps: {
        imageCount: this.pendingHazardImageFiles.length,
      },
      showBackdrop: true,
    });
    await modal.present();

    const { data } = await modal.onDidDismiss<UploadConfirmationResult>();
    const action = data?.action ?? 'cancel';

    if (action === 'cancel') {
      this.pendingHazardImageFiles = [];
      return;
    }

    if (action === 'upload') {
      await this.processHazardImagesAndUpload(this.pendingHazardImageFiles);
      this.pendingHazardImageFiles = [];
      return;
    }

    if (action === 'edit') {
      const filesToEdit = [...this.pendingHazardImageFiles];
      this.pendingHazardImageFiles = [];

      // Export as JPEG (quality 0.92) to keep file sizes comparable to the originals.
      // PNG is lossless and inflates typical 4 MB JPEGs to 25–30 MB because it must
      // store the full decoded pixel data; JPEG compresses photo-realistic images far
      // more efficiently. exportQuality only affects JPEG — it has no effect on PNG.
      const editedFiles: File[] = await this.imageEditorService.openBatch(filesToEdit, {
        exportFormat: 'jpeg',
        exportQuality: 0.92,
      });

      if (editedFiles.length === 0) {
        return;
      }

      // PNG lossless export can make files significantly larger than the originals.
      // Re-validate size so oversized edited files don't reach the upload API.
      const validSizeEditedFiles = editedFiles.filter(file => file.size <= this.MAX_HAZARD_IMAGE_SIZE);
      const oversizedEditedCount = editedFiles.length - validSizeEditedFiles.length;
      if (oversizedEditedCount > 0) {
        const maxMB = (this.MAX_HAZARD_IMAGE_SIZE / (1024 * 1024)).toFixed(0);
        this.toastService.presentToast(
          this.translate.instant('image_size_exceeds_limit', { count: oversizedEditedCount, max: maxMB }),
          4000,
          AppConstants.WARNING_SNACKBAR,
          'top'
        );
      }

      if (validSizeEditedFiles.length === 0) {
        return;
      }

      await this.processHazardImagesAndUpload(validSizeEditedFiles);
    }
  }

  /**
   * Validates the given files and triggers the upload if valid.
   * Extracted from the old `inputHazardImg` logic to be reused by both
   * "Upload Directly" and "Edit Images" paths.
   */
  private async processHazardImagesAndUpload(files: File[]): Promise<void> {
    this.imageFiles = files;
    let isInvalid = false;

    for (const file of this.imageFiles) {
      if (!file?.name || file.name.trim().length === 0 || file.name.length > 100) {
        isInvalid = true;
        break;
      }
    }

    if (isInvalid) {
      this.toastService.presentToast(
        this.translate.instant('image_name_validation'),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      return;
    }

    for (const file of this.imageFiles) {
      const reader = new FileReader();
      const fileSize = file.size;
      const imgData = {
        fileName: file.name,
        fileSize: file.size,
        fileReaderResult: reader.result,
        fileData: file
      };
      reader.onload = () => {
        this.reviewImageSrc = reader.result;
        imgData.fileReaderResult = reader.result;
        this.previewHazardFile.push(imgData);
      };
      reader.readAsDataURL(file);
    }

    this.uploadHazardImages();
  }

  /**
   * Opens an existing hazard image (from web upload or mobile upload) in the
   * image editor. On apply, uploads the edited file and replaces the record
   * in-place preserving fileName and orderNo. Old blob is queued for deletion
   * and flushed on save.
   */
  public async editHazardImage(item: any, index: number): Promise<void> {
    if (!item || item.isView || this.isReadonlyHazard || this.isEditingImage) {
      return;
    }
    if (!item.url) {
      return;
    }

    this.editingImageIndex = index;
    let inputFile: File;
    try {
      const response = await fetch(item.url, { mode: 'cors' });
      if (!response.ok) {
        throw new Error(`Failed to fetch image (status ${response.status})`);
      }
      const blob = await response.blob();
      const preservedName = item.fileName || `image-${index}`;
      inputFile = new File([blob], preservedName, { type: blob.type || 'image/jpeg' });
    } catch (err) {
      console.error('[editHazardImage] Unable to load image for editing', err);
      this.editingImageIndex = null;
      return;
    }

    try {
      const result = await this.imageEditorService.openWithPreset(inputFile, 'highQuality');
      if (result.cancelled || !result.file) {
        return;
      }
      await this.replaceHazardImage(item, result.file);
    } finally {
      this.editingImageIndex = null;
    }
  }

  /**
   * Uploads the edited file and swaps it into hazardImagesRes at the same
   * position as `oldItem`. Preserves fileName + orderNo; queues the old blob
   * for deletion (flushed on save via flushPendingImageDeletes).
   */
  private async replaceHazardImage(oldItem: any, newFile: File): Promise<void> {
    const filePath = `${this.projectId}/${this.serviceId}/${this.machineId}/${this.roadmapId}/`;
    const formData = new FormData();
    const payload = this.sharedValue.prepareImageFormData(formData, [newFile], filePath);

    return new Promise<void>((resolve) => {
      this.backendService.uploadImages(payload).subscribe((res: any[]) => {
        const uploaded = res?.[0];
        if (!uploaded) {
          resolve();
          return;
        }

        // Queue deletion of old blob if it was already persisted on the server.
        if (oldItem?.hazardMediaId !== null && oldItem?.hazardMediaId !== undefined) {
          this.queueImageDelete({
            resourceType: 2,
            id: oldItem.hazardMediaId,
            fileName: oldItem.fileName,
            filePath: oldItem.url,
            modifiedBy: this.userAuthService.getUserList().userId
          });
        }

        const replacement = {
          ...oldItem,
          url: uploaded.url,
          contentType: uploaded.content_type,
          image_Size: uploaded.file_size,
          // Treat as an unsaved new record; server will persist it on save.
          hazardMediaId: null
        };

        const idx = this.hazardImagesRes.findIndex(x => x === oldItem);
        if (idx > -1) {
          this.hazardImagesRes.splice(idx, 1, replacement);
        }

        this.updateHazardStepState();
        this.changeDetectorRef.detectChanges();
        resolve();
      }, (err) => {
        console.error('[replaceHazardImage] Upload failed', err);
        resolve();
      });
    });
  }

  private async uploadHazardImages() {
    const file_path = `${this.projectId}/${this.serviceId}/${this.machineId}/${this.roadmapId}/`;
    const formData = new FormData();
    const hazardImageFormData = this.sharedValue.prepareImageFormData(formData, this.imageFiles, file_path)
    
    // Calculate next order number BEFORE API call and reserve the range for this batch
    const startingOrderNo = this.getNextAvailableOrderNo();
    const numberOfFiles = this.imageFiles.length;
    // Update pendingNextOrderNo immediately to reserve these numbers for concurrent uploads
    this.pendingNextOrderNo = startingOrderNo + numberOfFiles - 1;
    
    await this.backendService.uploadImages(hazardImageFormData).subscribe((res: any) => {
      // Use the pre-calculated starting order number
      let nextOrderNo = startingOrderNo;
      
      // Collect new images first to insert at the beginning
      const newImages: any[] = [];
      
      res.forEach(element => {
        // Generate random 4-digit number for filename
        const random4Digit = this.generateRandom4Digit();
        // Generate filename in format: HZD_<random4digit>_Image_<orderNo>
        const generatedFileName = `HZD_${random4Digit}_Image_${nextOrderNo}`;
        
        const imageData = {
          fileName: generatedFileName,
          contentType: element?.content_type,
          url: element?.url,
          image_Size: element?.file_size,
          orderNo: nextOrderNo
        };
        newImages.push(imageData);
        this.hazardImagesList.push(imageData);
        nextOrderNo++;
      });
      
      // Add new images at the end of the array to maintain sequential order (Image_1, Image_2, Image_3, etc.)
      this.hazardImagesRes.push(...newImages);
      
      // Trigger change detection to update the UI with new file names
      this.updateHazardStepState();
      this.changeDetectorRef.detectChanges();
    }, (err) => {
    });
  }

  public deleteImage(params, i) {
    const imageIndex = this.hazardImagesRes.findIndex(image =>
      image === params ||
      (params?.hazardMediaId && image?.hazardMediaId === params.hazardMediaId) ||
      (!params?.hazardMediaId && image?.url === params?.url)
    );

    if (imageIndex === -1) {
      return;
    }

    if (params.hazardMediaId !== null && params.hazardMediaId !== undefined) {
      const  payload =  {
        resourceType: 2,
        id: params.hazardMediaId,
        fileName: params.fileName,
        filePath: params.url,
        modifiedBy: this.userAuthService.getUserList().userId
      }
      this.queueImageDelete(payload);
    }

    this.hazardImagesRes.splice(imageIndex, 1);
    this.updateHazardStepState();
    this.toastService.presentToast(this.translate.instant('img-deleted-succesfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
  }

  async deleteImageConfirmation(params, i){
    const itemName = this.translate.instant('image').toLowerCase(); 
    const title = this.translate.instant('Are_you_sure_you_want_to_delete')+ ' ' + itemName + '?';
    const subtitleName = params?.fileName;
    const subtitle = subtitleName ? `'${subtitleName}'` : null;
    const actionText = this.translate.instant('Delete');
    const isConfirmed = await this.confirmationService.presentConfirmationModal(title, actionText, true, this.translate.instant('Cancel'), subtitle);
    if (isConfirmed) {
      this.deleteImage(params, i);
    }
  }

  /**
   * Opens pictogram popup
   */
  async openPictogramPopup() {
    const existingIds = this.pictogramImages
      .map(p => p.pictogramImageId || p.id)
      .filter(id => !!id);

    const modal = await this.modalController.create({
      component: PictogramLibraryComponent,
      cssClass: 'pictogram-library-modal',
      backdropDismiss: false,
      componentProps: { existingPictogramIds: existingIds },
      showBackdrop: false,
    });
    await modal.present();
    const result = await modal.onDidDismiss();
    if (result?.data?.selectedImages?.length) {
      const startingOrderNo = this.pictogramImages.length + 1;
      result.data.selectedImages.forEach((image: any, index: number) => {
        this.pictogramImages.push({
          url: image.url,
          thumbnailUrl: image.thumbnailUrl,
          displayName: image.fileName,
          fileName: image.fileName,
          pictogramImageId: image.id,
          categoryId: image.categoryId,
          categoryName: image.categoryName,
          orderNo: startingOrderNo + index,
        });
      });
      this.rebuildGroupedPictogramImages();
      this.updateHazardStepState();
      this.changeDetectorRef.detectChanges();
    }
  }

  /**
   * Deletes a pictogram image
   */
 public deletePictogramImage(item) {
    const index = this.pictogramImages.indexOf(item);
    if (index === -1) return;

    if (item.hazardPictogramMediaId !== null && item.hazardPictogramMediaId !== undefined) {
      const payload = {
        resourceType: 8,
        id: item.hazardPictogramMediaId,
        fileName: item.displayName,
        filePath: item.url,
        modifiedBy: this.userAuthService.getUserList().userId
      };
      this.queueImageDelete(payload);
    }

    this.pictogramImages.splice(index, 1);
    this.rebuildGroupedPictogramImages();
    this.updateHazardStepState();
    this.toastService.presentToast(this.translate.instant('img-deleted-succesfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
    this.changeDetectorRef.detectChanges();
  }

  async deletePictogramConfirmation(item) {
    const itemName = this.translate.instant('image').toLowerCase();
    const title = this.translate.instant('Are_you_sure_you_want_to_delete') + ' ' + itemName + '?';
    const subtitleName = item?.displayName || item?.fileName;
    const subtitle = subtitleName ? `'${subtitleName}'` : null;
    const actionText = this.translate.instant('Delete');
    const isConfirmed = await this.confirmationService.presentConfirmationModal(title, actionText, true, this.translate.instant('Cancel'), subtitle);
    if (isConfirmed) {
      this.deletePictogramImage(item);
    }
  }

  async complete(form: NgForm, saveAsDraft = this.isSaveAsDraft): Promise<boolean> {
    const saved = await this.completedData(form, saveAsDraft);
    if (saved) {
      this.previewHazardFile = [];
    }
    return saved;
  }

  reverseMapToEnglish: { [key: string]: string } = {
    // Normal
    'Normal': 'Normal',       // English, French, German, Spanish, Portuguese
    'Normale': 'Normal',      // Italian
  
    // Other
    'Other': 'Other',         // English
    'Autre': 'Other',         // French
    'Altro': 'Other',         // Italian
    'Andere': 'Other',        // German
    'Outro': 'Other',         // Portuguese
    'Otro': 'Other',          // Spanish
  
    // Setup
    'Setup': 'Setup',         // English
    'Configuration': 'Setup', // French
    'Configurazione': 'Setup',  // Italian
    'Einrichtung': 'Setup',   // German
    'Configuração': 'Setup',  // Portuguese
    'Configuración': 'Setup', // Spanish
  
    // Maintenance
    'Maintenance': 'Maintenance',     // English
    'Entretien': 'Maintenance',       // French
    'Manutenzione': 'Maintenance',    // Italian
    'Wartung / Instandhaltung': 'Maintenance',         // German
    'Manutenção': 'Maintenance',      // Portuguese
    'Mantenimiento': 'Maintenance'    // Spanish
  };

  isSameListById(current: any[], original: any[]) {
    if (!Array.isArray(current) || !Array.isArray(original)) return false;
    if (current.length !== original.length) return false;

    const currentIds = current.map(c => c.hazardConsequenceId || c.id).sort();
    const originalIds = original.map(c => c.id).sort();

    return JSON.stringify(currentIds) === JSON.stringify(originalIds);
  }

  async completedData(form: NgForm, saveAsDraft = this.isSaveAsDraft): Promise<boolean> {
    if (this.isEditingFourEyeQuality) {
      this.saveFourEyeQualityEditInfo(form?.value);
      return true;
    }

    if (this.initialHazardMeasureComponent) {
      this.handleMeasuresUpdate(this.initialHazardMeasureComponent.getMeasuresSnapshot());
    }

    if (!saveAsDraft && !this.validateHazardForStandardSave()) {
      return false;
    }

    if (!saveAsDraft && this.hasIncompleteMeasure()) {
      this.showMeasureValidationErrors = true;
      this.updateHazardStepState();
      this.toastService.presentToast(
        this.translate.instant('measure_required_details'),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      return false;
    }

    if (!saveAsDraft && this.hasWhitespaceOnlyMeasureNames()) {
      this.showMeasureValidationErrors = true;
      this.toastService.presentToast(this.translate.instant('check_measure_names_only_spaces_not_allowed'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      return false;
    }

    this.showMeasureValidationErrors = false;
    const payload = this.buildHazardPayload(form, saveAsDraft);
    const saved = await this.saveHazardInfo(payload, saveAsDraft);
    if (saved) {
      this.resetHazardSteps();
    }
    return saved;
  }

  private buildHazardPayload(form: NgForm, saveAsDraft = false) {
    const formValue = form?.value || {};

    // Build HRN data only if machine modes are selected
    let finalHrNs = [];
    const rawMachineModes = formValue?.hazardTypesData?.machineMode || [];
    const formMachineModes = Array.isArray(rawMachineModes) ? rawMachineModes : rawMachineModes ? [rawMachineModes] : [];
    const machineModes = formMachineModes.length > 0 ? formMachineModes : (this.machineModeLists || []);
    const getRatingData = (tableName: 'chrnTable' | 'ihrnTable', dataKey: 'dataChrn' | 'dataIhrn', listName: string, modeValue: string) => {
      const tableValue = formValue?.[tableName]?.[listName]?.[modeValue];
      const ratingValue = this.hazardRatingList.find(rating => rating.listName === listName)?.[dataKey]?.[modeValue];
      return tableValue || ratingValue || null;
    };
    const hasHrnValue = (value: any) => value?.id !== undefined && value?.id !== null && value?.id !== '';
    const getHrnId = (value: any) => hasHrnValue(value) ? this.normalizeHazardIdentifier(value.id) : '';
    const getHrnRating = (values: any[]) => {
      if (!values.every(hasHrnValue)) {
        return '';
      }

      return Math.round(
        (values[0]?.value || 1) *
        (values[1]?.value || 1) *
        (values[2]?.value || 1) *
        (values[3]?.value || 1)
      ).toString();
    };
    const buildHrnEntry = (hrnType: 'Current' | 'Indicative', tableName: 'chrnTable' | 'ihrnTable', dataKey: 'dataChrn' | 'dataIhrn', modeValue: string) => {
      const po = getRatingData(tableName, dataKey, 'Probability of Occurrence', modeValue);
      const sd = getRatingData(tableName, dataKey, 'Degree of Severity', modeValue);
      const fe = getRatingData(tableName, dataKey, 'Frequency of Exposition', modeValue);
      const np = getRatingData(tableName, dataKey, 'Number of Persons Exposed', modeValue);
      const values = [po, sd, fe, np];

      if (!saveAsDraft && !values.every(hasHrnValue)) {
        return null;
      }

      const mode = this.reverseMapToEnglish[modeValue] || modeValue;
      const entry: any = {
        hrnType,
        mode,
        po: getHrnId(po),
        sd: getHrnId(sd),
        fe: getHrnId(fe),
        np: getHrnId(np),
        rating: getHrnRating(values)
      };

      if (hrnType === 'Indicative') {
        const conformity = this.conformityStatus[modeValue];
        entry.cStatus = conformity?.c_status || '';
        entry.cStatusId = conformity?.c_status_id || 0;
      }

      return entry;
    };
    
    if (machineModes.length > 0) {
      machineModes.forEach(_element => {
        const modeValue = this.getMachineModeValue(_element);
        if (!modeValue) {
          return;
        }

        const currentHrn = buildHrnEntry('Current', 'chrnTable', 'dataChrn', modeValue);
        if (currentHrn) {
          finalHrNs.push(currentHrn);
        }
      });

      machineModes.forEach(_element => {
        const modeValue = this.getMachineModeValue(_element);
        if (!modeValue) {
          return;
        }

        const indicativeHrn = buildHrnEntry('Indicative', 'ihrnTable', 'dataIhrn', modeValue);
        if (indicativeHrn) {
          finalHrNs.push(indicativeHrn);
        }
      });
    }

    // Handle sources (optional)
    const selectedSources = this.getSelectedHazardSources();
    const originalSources = this.hazardInfo?.hazardType?.hazardSources || [];
    const mappedSources = Array.isArray(selectedSources)
      ? selectedSources.map((element: any) => ({
          id: element.hazardSourceId || '',
          value: element.source || element
        }))
      : [];
    const finalSources = this.isSameListById(selectedSources, originalSources) ? originalSources : mappedSources;

    // Handle consequences (optional)
    const selectedConsequences = this.getSelectedHazardConsequences();
    const originalConsequences = this.hazardInfo?.hazardType?.hazardConsequences || [];
    const mappedConsequences = Array.isArray(selectedConsequences)
      ? selectedConsequences.map((element: any) => ({
          id: element.hazardConsequenceId || '',
          value: element.consequence || element
        }))
      : [];
    const finalConsequences = this.isSameListById(selectedConsequences, originalConsequences) ? originalConsequences : mappedConsequences;

    // Handle hazard type (optional)
    const hazardTypeData = this.getSelectedHazardType();
    const hazardTypeId = hazardTypeData?.hazardTypeId || '';
    const hazardTypeName = hazardTypeData?.hazardTypeName || '';

    // Handle machine modes for initialHazards (optional)
    const selectedMachineModes = machineModes.length > 0
      ? machineModes.map(mode => ({
          id: mode?.id || '',
          value: this.reverseMapToEnglish[this.getMachineModeValue(mode)] || this.getMachineModeValue(mode)
        }))
      : [];

    // Build hazardType object - send null if completely empty, otherwise send as-is for backend validation
    const hazardTypeObj = {
      id: hazardTypeId,
      hazardType: hazardTypeName,
      sources: finalSources,
      consequences: finalConsequences
    };
    const isHazardTypeEmpty = !hazardTypeId && !hazardTypeName && finalSources.length === 0 && finalConsequences.length === 0;

    // Build hazardRatingnumber object - send null if no HRN data
    const hazardRatingnumberObj = saveAsDraft
      ? { machineModes: selectedMachineModes, hazardRating: finalHrNs }
      : { hazardRating: finalHrNs };
    const isHazardRatingEmpty = saveAsDraft
      ? selectedMachineModes.length === 0 && finalHrNs.length === 0
      : finalHrNs.length === 0;

    // Build initialHazards object - send null if completely empty
    const initialHazard = this.hazardInfo?.initialHazards?.initial_hazard || '';
    const initialHazardsObj = {
      initial_hazard: initialHazard,
      machineModes: selectedMachineModes
    };
    const isInitialHazardsEmpty = !initialHazard && selectedMachineModes.length === 0;

    // Build plrObj - send null if completely empty
    const plrCategory = this.hazardInfo?.plrObj?.category || '';
    const plrValue = this.hazardInfo?.plrObj?.plr || '';
    const sValue = this.hazardInfo?.plrObj?.sValue || '';
    const fValue = this.hazardInfo?.plrObj?.fValue || '';
    const pValue = this.hazardInfo?.plrObj?.pValue || '';
    const plrDescription = this.hazardInfo?.plrObj?.plrDescription || '';
    const isPlrFromGraph = this.hazardInfo?.plrObj?.isPlrFromGraph || false;
    let plrObjData  = {}
     if (isPlrFromGraph) {
       plrObjData = {
      category: plrCategory,
      sValue: sValue,
      plrDescription : plrDescription,
      isPlrFromGraph : isPlrFromGraph,
    };
     }else {
        plrObjData = {
      category: plrCategory,
      plr: plrValue,
      sValue: sValue,
      fValue: fValue,
      pValue: pValue,
      plrDescription : plrDescription,
      isPlrFromGraph : isPlrFromGraph,
    };
     }
   
    const isPlrObjEmpty = !plrCategory && !plrValue && !sValue && !fValue && !pValue &&  !plrDescription;
    const hazardLocation = saveAsDraft ? this.getSanitizedHazardLocation() : this.getHazardLocationForSave();

    let payload = {
      id: this.hazardId,
      hazardName: this.normalizeHazardIdentifier(this.hazardInfo?.hazardName).trim(),
      hazardLocation,
      roadmapId: this.roadmapId,
      stepId: this.stepId,
      version: this.version,
      hazardType: isHazardTypeEmpty ? null : hazardTypeObj,
      hazardRatingnumber: isHazardRatingEmpty ? null : hazardRatingnumberObj,
      initialHazards: isInitialHazardsEmpty ? null : initialHazardsObj,
      controlMeasure: this.hazardInfo?.controlMeasure || '',
      controlMeasures: (this.dynamicMeasures || []).map(measure => ({
        ...measure,
        measure_type_id: measure?.measure_type_id === '' || measure?.measure_type_id === undefined ? 0 : measure.measure_type_id,
        short_name: measure?.short_name?.trim() || ''
      })),
      hazardMedia: this.getHazardMediaPayload(),
      pictogramHazardMedia: this.pictogramImages || [],
      plrObj: isPlrObjEmpty ? null : plrObjData
    };

    return payload;
  }

  // completedData(form: NgForm) {
  //   if (form.valid) {
  //     if (this.isEditingFourEyeQuality) {
  //       this.saveFourEyeQualityEditInfo(form.value);
  //     }
  //     else {
  //       if (!this.checkHRNData()) {
  //         return;
  //       }
  //     let finalHrNs = [];
  //     form.value.hazardTypesData.machineMode.forEach(_element => {
  //       let values = {
  //         hrnType: "Current",
  //         mode: this.reverseMapToEnglish[_element.value] || _element.value,
  //         po: form.value.chrnTable['Probability of Occurrence'][_element.value].id,
  //         sd: form.value.chrnTable['Degree of Severity'][_element.value].id,
  //         fe: form.value.chrnTable['Frequency of Exposition'][_element.value].id,
  //         np: form.value.chrnTable['Number of Persons Exposed'][_element.value].id,
  //         rating: Math.round(form.value.chrnTable['Probability of Occurrence'][_element.value].value *
  //           form.value.chrnTable['Degree of Severity'][_element.value].value *
  //           form.value.chrnTable['Frequency of Exposition'][_element.value].value *
  //           form.value.chrnTable['Number of Persons Exposed'][_element.value].value).toString()
  //       }
  //       finalHrNs.push(values);
  //     });
  //     form.value.hazardTypesData.machineMode.forEach(_element => {
  //       const mode = this.reverseMapToEnglish[_element.value] || _element.value;
  //       const conformity = this.conformityStatus[_element.value];
  //       let values = {
  //         hrnType: "Indicative",
  //         mode: mode,
  //         po: form.value.ihrnTable['Probability of Occurrence'][_element.value].id,
  //         sd: form.value.ihrnTable['Degree of Severity'][_element.value].id,
  //         fe: form.value.ihrnTable['Frequency of Exposition'][_element.value].id,
  //         np: form.value.ihrnTable['Number of Persons Exposed'][_element.value].id,
  //         rating: Math.round(form.value.ihrnTable['Probability of Occurrence'][_element.value].value *
  //           form.value.ihrnTable['Degree of Severity'][_element.value].value *
  //           form.value.ihrnTable['Frequency of Exposition'][_element.value].value *
  //           form.value.ihrnTable['Number of Persons Exposed'][_element.value].value).toString(),
  //         cStatus: conformity && conformity.c_status ? conformity.c_status : '',
  //         cStatusId: conformity && conformity.c_status_id ? conformity.c_status_id : 0
  //       }
  //       finalHrNs.push(values);
  //     });
  //     const selectedSources = form.value.hazardTypesData?.source;
  //     const originalSources = this.hazardInfo.hazardType?.hazardSources || [];
  //     const mappedSources = Array.isArray(selectedSources)
  //       ? selectedSources.map((element: any) => ({
  //         id: element.hazardSourceId || '',
  //         value: element.source || element
  //       }))
  //       : selectedSources ?
  //         [{
  //           id: selectedSources?.hazardSourceId || selectedSources,
  //           value: selectedSources?.source || selectedSources
  //         }]
  //       : [];
  //     const finalSources = this.isSameListById(selectedSources, originalSources) ? originalSources : mappedSources;
  //     const selectedConsequences = form.value.hazardTypesData?.consequence;
  //     const originalConsequences = this.hazardInfo.hazardType?.hazardConsequences || [];
  //     const mappedConsequences = Array.isArray(selectedConsequences)
  //       ? selectedConsequences.map((element: any) => ({
  //           id: element.hazardConsequenceId || '',
  //           value: element.consequence || element
  //         }))
  //       : selectedConsequences ?
  //         [{
  //           id: selectedConsequences?.hazardConsequenceId || selectedConsequences,
  //           value: selectedConsequences?.consequence || selectedConsequences
  //         }]
  //       : [];
  //     const finalConsequences = this.isSameListById(selectedConsequences, originalConsequences) ? originalConsequences : mappedConsequences;
  //     let payload = {    
  //       id: this.hazardId,
  //       hazardName: form.value.hazardName.trim(),
  //       roadmapId: this.roadmapId,
  //       stepId: this.stepId,
  //       version: this.version,
  //       hazardType: {
  //         id: form.value.hazardTypesData.hazardType == this.hazardInfo.hazardType.hazardTypeName
  //           ? this.hazardInfo.hazardType.id
  //           : form.value.hazardTypesData.hazardType?.hazardTypeId,
  //         hazardType: form.value.hazardTypesData.hazardType == this.hazardInfo.hazardType.hazardTypeName
  //           ? this.hazardInfo.hazardType.hazardTypeName
  //           : form.value.hazardTypesData.hazardType?.hazardTypeName,
  //         sources: finalSources,
  //         consequences: finalConsequences
  //       },
  //       hazardRatingnumber: {
  //         hazardRating: finalHrNs
  //       },
  //       initialHazards: {
  //         initial_hazard: this.hazardInfo.initialHazards?.initial_hazard || '',
  //         machineModes: form.value.hazardTypesData.machineMode.map(mode => ({
  //           id: mode.id || '',
  //           value: this.reverseMapToEnglish[mode.value] || mode.value
  //         }))
  //       },
  //       controlMeasure: this.hazardInfo.controlMeasure,
  //       controlMeasures: this.dynamicMeasures,
  //       hazardMedia: this.hazardImagesRes,
  //       plrObj: {
  //         category: this.hazardInfo?.plrObj?.category,
  //         plr: this.hazardInfo?.plrObj?.plr,
  //         sValue: this.hazardInfo?.plrObj?.sValue,
  //         fValue: this.hazardInfo?.plrObj?.fValue,
  //         pValue: this.hazardInfo?.plrObj?.pValue
  //       }
  //     };
  //     this.saveHazardInfo(payload);
  //       this.resetHazardSteps();
  //     }
  //   } else {
  //     form.form.markAllAsTouched();
  //     this.toastService.presentToast('Please fill all the mandatory fields', 4000, AppConstants.ERROR_SNACKBAR, 'top');
  //   }
  // }

  public async saveHazardInfo(hazard, saveAsDraft = false): Promise<boolean> {
    if (!await this.validatePersistedHazardImages()) {
      return false;
    }

    hazard.hazardMedia = this.getHazardMediaPayload();
    const saveRequest = saveAsDraft
      ? this.backendService.upsertHazardDraft(hazard)
      : this.backendService.upsertHazard(hazard);

    return new Promise<boolean>((resolve) => {
      saveRequest.subscribe({
        next: (data: any) => {
            if (data.statusCode === 200) {
                this.hasCompletedHazardSave = true;
                this.unsavedChangesService.clearGuard(this.unsavedChangesGuardHandler);
                this.flushPendingImageDeletes();
                const successMessage = saveAsDraft
                  ? data?.value || data?.message || this.translate.instant('hazard_saved_successfully')
                  : this.translate.instant('hazard_saved_successfully');
                this.toastService.presentToast(
                  successMessage,
                     4000, 
                     AppConstants.SUCCESS_SNACKBAR, 
                     'top'
                );
                this.hazardInfo = null;
                this.hazardImagesRes = [];
                this.resetHazardRatingList();
                // Emit updated sections and reset state
                this.exitHazardDetails.emit(this.stepId);
                resolve(true);
            } else {
                this.toastService.presentToast(
                    this.translate.instant('one_or_more_fields_missing_validation'), 
                    4000, 
                    AppConstants.ERROR_SNACKBAR, 
                    'top'
                );
                  resolve(false);
            }
        },
        error: (error) => {
          if(error.status === 400) {
            this.toastService.presentToast(
              this.translate.instant('one_or_more_fields_missing_validation'),
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            );
            resolve(false);
            return;
          }
            this.toastService.presentToast(
              this.translate.instant('failed_to_save_hazard'),
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            );
            console.error('Error saving hazard:', error);
            resolve(false);
        }
      });
    });
}

  saveFourEyeQualityEditInfo(hazardInfo) {
    const body = {
      hazardTypeId: '',
      hazardType: this.getSelectedHazardType(),
      source: this.getSelectedHazardSources(),
      consequences: this.getSelectedHazardConsequences()
    };
    this.addNewHazardDetails.push(body);
    this.hazardSourceConnsequencesData = JSON.parse(JSON.stringify(this.addNewHazardDetails));
    if (hazardInfo && hazardInfo.hazardName) {
      const hazardPayload = this.sharedValue.initializeEditFourEyeHazardLists(this.recommendedCategoryValue,
        this.hardDetailsData.id,
        hazardInfo,
        this.machineModeLists,
        this.riskResassessmentmachineModeLists,
        this.riskMachineModesWithIds,
        this.machineModeWithIdsLists,
        this.hazardRatingList,
        this.addNewHazardDetails,
        this.hazardImagesRes,
        this.hazardSourceConnsequencesData,
        this.hardDetailsData);
      setTimeout(() => {
        if (hazardPayload && hazardPayload.id) {
          this.backendService.saveEditedHazardInfoInFourEyeQuality(hazardPayload).then(res => {
            if (res && res.statusCode == 200) {
              this.hasCompletedHazardSave = true;
              this.unsavedChangesService.clearGuard(this.unsavedChangesGuardHandler);
              this.flushPendingImageDeletes();
              this.toastService.presentToast(this.translate.instant('hazard_edited_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
              // this.sharedValue.editHazardPayload.push({id:hazardPayload.id,name:hazardPayload.name});
              const state = {
                hazardDetails: { hazardRatingList: this.hazardRatingList, 
                  formData: hazardInfo, 
                          files: this.getHazardMediaPayload(), 
                  pickCntrlMeasureValue: this.pickCntrlMeasureValue,
                  pickInitialHazardValue: this.pickInitialHazardValue, 
                  determinePlrValue: this.hardDetailsData.determinePlrValue, 
                  isEdited: this.isEditingFourEyeQuality, 
                  editedHazardId: this.hardDetailsData.id },
                  sectionData: this.sectionData
              };
              this.sharedValue.editHazardPayload = state;
              this.selectedStep = this.hazardSteps[0].val;
              this.updateHazardStepState();
              this.goBack();
            }
          }).catch(err => {
            console.log('getting issue in saving hazard info for 4-eye quality :', err);
          });
        }
      }, 400);
    }
  }

  async goBack() {
    const canLeave = await this.confirmLeaveHazardWizard('exit');
    if (!canLeave) {
      return;
    }

    if (this.hasCompletedHazardSave) {
      return;
    }

    this.discardHazardWizard();
  }

  private discardHazardWizard(): void {
    this.hasCompletedHazardSave = true;
    this.unsavedChangesService.clearGuard(this.unsavedChangesGuardHandler);
    this.resetHazardSteps();
    this.pendingImageDeletePayloads = [];
    this.hazardImagesRes = [];
    this.hazardInfo = null;
    this.resetHazardRatingList();
    this.pendingNextOrderNo = 0; // Reset pending order number
    this.subs.unsubscribe();
    this.exitHazardDetails.emit(this.stepId);
  }

  onHazardTypeChange(ev?: any) {
    const selectedType = typeof ev === 'string'
      ? this.translatedHazardTypeList.find((item) => this.normalizeHazardIdentifier(item.hazardTypeId) === this.normalizeHazardIdentifier(ev)) || null
      : ev || this.getSelectedHazardType();

    this.selectedHazardTypeId = this.normalizeHazardIdentifier(selectedType?.hazardTypeId || (typeof ev === 'string' ? ev : ''));
    this.selectedHazardTypeName = selectedType;
    this.hazardSources = selectedType ? selectedType.hazardSources : [];
    this.hazardConsequences = selectedType ? selectedType.hazardConsequences : [];

    if (this.isSyncingHazardDropdownSelections) {
      this.changeDetectorRef.detectChanges();
      return;
    }

    this.selectedHazardSourceIds = [];
    this.selectedHazardConsequenceIds = [];
    this.selectedHazardSourceName = [];
    this.selectedHazardConsequenceName = [];
    this.updateHazardStepState();
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Resets hazard steps to their original state.
   */
  public resetHazardSteps(): void {
    this.hazardSteps = JSON.parse(JSON.stringify(this.originalHazardSteps));
    this.updateHazardStepState();
  }

  public updateHazardStepState(): void {
    const currentIndex = this.hazardSteps.findIndex(step => step.val === this.selectedStep);

    this.hazardSteps.forEach((step, index) => {
      const isComplete = this.isHazardStepComplete(step.val);
      const hasPartialData = !isComplete && this.isHazardStepPartial(step.val);
      const isPartial = hasPartialData;
      step.isdone = isComplete;
      step.isPartial = isPartial;
      step.isCurrent = index === currentIndex;
      // A step is active if: complete, current (and not partial), OR has partial data (visited/started)
      // This allows incomplete steps with partial data to show as orange
      step.isActive = isComplete || (index === currentIndex && !isPartial) || isPartial;
    });
  }

  private isHazardStepComplete(stepValue: string): boolean {
    switch (stepValue) {
      case 'hi':
        return this.isHazardNameStepComplete();
      case 'hd':
        return this.isHazardDetailsStepComplete();
      case 'chr':
        return this.isCurrentHrnStepComplete();
      case 'hch':
        return this.isMeasureStepComplete();
      case 'hrn':
        return this.isResidualHrnStepComplete();
      default:
        return false;
    }
  }

  private isHazardStepPartial(stepValue: string): boolean {
    switch (stepValue) {
      case 'hi':
        return this.isHazardNameStepPartial();
      case 'hd':
        return this.isHazardDetailsStepPartial();
      case 'chr':
        return this.hasAnyCurrentHrnSelection();
      case 'hch':
        return this.hasAnyMeasureFieldStarted();
      case 'hrn':
        return this.hasAnyResidualHrnSelection();
      default:
        return false;
    }
  }

  private isHazardNameStepComplete(): boolean {
    const hazardName = this.hazardInfo?.hazardName || '';
    return hazardName.trim().length > 0 && hazardName.length <= 100 && this.hazardNamePattern.test(hazardName);
  }

  private isHazardNameStepPartial(): boolean {
    const hazardName = this.hazardInfo?.hazardName || '';
    return hazardName.length > 0 || this.allHazardImages?.length > 0 || this.pictogramImages?.length > 0;
  }

  private isHazardDetailsStepComplete(): boolean {
    return this.getSelectedMachineModeValues().length > 0 &&
      !!this.selectedHazardTypeId &&
      Array.isArray(this.selectedHazardSourceIds) && this.selectedHazardSourceIds.length > 0 &&
      Array.isArray(this.selectedHazardConsequenceIds) && this.selectedHazardConsequenceIds.length > 0 &&
      this.isInitialHazardComplete();
  }

  // Navigation validation - only checks mandatory fields for blocking navigation
  private isHazardStepRequiredForNavigation(stepValue: string): boolean {
    switch (stepValue) {
      case 'hi':
        return this.isHazardNameStepComplete();
      case 'hd':
        return this.isHazardDetailsStepComplete();
      case 'chr':
        return this.isCurrentHrnStepComplete();
      case 'hch':
        return this.areAllMeasuresComplete();
      case 'hrn':
        return this.isResidualHrnStepComplete();
      default:
        return false;
    }
  }

  private isHazardDetailsStepPartial(): boolean {
    return this.getSelectedMachineModeValues().length > 0 ||
      !!this.selectedHazardTypeId ||
      (Array.isArray(this.selectedHazardSourceIds) && this.selectedHazardSourceIds.length > 0) ||
      (Array.isArray(this.selectedHazardConsequenceIds) && this.selectedHazardConsequenceIds.length > 0) ||
      this.isInitialHazardPartial();
  }

  private isHazardLocationComplete(): boolean {
    return !!this.getSanitizedHazardLocation();
  }

  private isHazardLocationPartial(): boolean {
    return this.normalizeHazardLocationValue(this.selectedHazardLocation).length > 0;
  }

  private isInitialHazardComplete(): boolean {
    return !!this.getInitialHazardValue().trim();
  }

  private isInitialHazardPartial(): boolean {
    return this.getInitialHazardValue().length > 0;
  }

  private getInitialHazardValue(): string {
    return this.normalizeHazardIdentifier(this.hazardInfo?.initialHazards?.initial_hazard || '');
  }

  private isCurrentHrnStepComplete(): boolean {
    const machineModeValues = this.getSelectedMachineModeValues();
    if (!machineModeValues.length) {
      return false;
    }

    return this.hazardRatingList.every(rating =>
      machineModeValues.every(modeValue => this.hasHrnSelection(rating.dataChrn?.[modeValue]))
    );
  }

  private isResidualHrnStepComplete(): boolean {
    const machineModeValues = this.getSelectedMachineModeValues();
    if (!machineModeValues.length) {
      return false;
    }

    const hasResidualHrnValues = this.hazardRatingList.every(rating =>
      machineModeValues.every(modeValue => this.hasHrnSelection(rating.dataIhrn?.[modeValue]))
    );
    const hasConformityStatus = machineModeValues.every(modeValue => !!this.conformityStatus?.[modeValue]?.c_status_id);

    return hasResidualHrnValues && hasConformityStatus;
  }

  private hasAnyCurrentHrnSelection(): boolean {
    return this.hasAnyHrnSelection('dataChrn');
  }

  private hasAnyResidualHrnSelection(): boolean {
    return this.hasAnyHrnSelection('dataIhrn');
  }

  private hasAnyHrnSelection(dataKey: 'dataChrn' | 'dataIhrn' | 'dataRiskChrn' | 'dataRiskIhrn'): boolean {
    const machineModeValues = this.getSelectedMachineModeValues();
    if (!machineModeValues.length) {
      return false;
    }

    return this.hazardRatingList.some(rating =>
      machineModeValues.some(modeValue => this.hasHrnSelection(rating[dataKey]?.[modeValue]))
    );
  }

  private isMeasureStepComplete(): boolean {
    // Step 4 shows initial hazard as read-only from step 2
    // We don't want filling initial hazard in step 2 to affect step 4's status
    // Step 4 should only turn blue when every added measure is complete
    return this.areAllMeasuresComplete();
  }

  private hasAnyMeasureFieldStarted(): boolean {
    // Step 4's status should not be affected by initial hazard from step 2
    // since it's displayed as read-only
    const measures = this.dynamicMeasures || [];
    if (measures.length === 0) {
      return false;
    }
    
    const hasAnyFieldData = measures.some(measure =>
      !!measure?.selectedMeasureType ||
      !!measure?.measure_type_id ||
      !!measure?.short_name?.trim() ||
      !!measure?.control_measure?.trim() ||
      !!measure?.measurePlrObj?.plr ||
      !!measure?.measurePlrObj?.sValue ||
      !!measure?.measurePlrObj?.category ||
      !!measure?.measurePlrObj?.recommendedCategory
    );
    
    return hasAnyFieldData;
  }

  private areAllMeasuresComplete(measures: any[] = this.dynamicMeasures || []): boolean {
    return measures.length > 0 && measures.every(measure => this.isMeasureComplete(measure));
  }

  private hasIncompleteMeasure(measures: any[] = this.dynamicMeasures || []): boolean {
    return measures.some(measure => !this.isMeasureComplete(measure));
  }

  private isMeasureComplete(measure: any): boolean {
    const measureTypeId = this.normalizeHazardIdentifier(measure?.selectedMeasureType?.measure_type_id || measure?.measure_type_id);
    const hasType = !!measure?.selectedMeasureType || !!(measureTypeId && this.sharedValue.measureTypes?.find(mt => this.normalizeHazardIdentifier(mt.measure_type_id) === measureTypeId));
    const hasMode = Array.isArray(measure?.machineModes) && measure.machineModes.length > 0;
    const hasDescription = !!measure?.control_measure?.trim();
    const isPLRType = measureTypeId === '3';
    const plr = measure?.measurePlrObj?.plr || measure?.measurePlrObj?.sValue;
    const category = measure?.measurePlrObj?.category?.toString().trim() || measure?.measurePlrObj?.recommendedCategory?.toString().trim();
    const includeCategory = !!measure?.measurePlrObj?.isIncludeRecommandedCategory;
    const hasValidPLR = !isPLRType || !!(plr && (!includeCategory || category));

    return hasType && hasMode && hasDescription && hasValidPLR;
  }

  private getSelectedMachineModeValues(): string[] {
    return (this.machineModeLists || [])
      .map(mode => this.getMachineModeValue(mode))
      .filter(modeValue => modeValue.length > 0);
  }

  public hasSelectedMachineModes(): boolean {
    return this.getSelectedMachineModeValues().length > 0;
  }

  private getMachineModeValue(mode: any): string {
    if (typeof mode === 'string') {
      return this.normalizeHazardIdentifier(mode);
    }

    return this.normalizeHazardIdentifier(mode?.value || mode?.mode_name || mode?.machineMode || mode?.name);
  }

  private hasHrnSelection(value: any): boolean {
    if (value === undefined || value === null || value === '') {
      return false;
    }

    if (typeof value !== 'object') {
      return true;
    }

    return value.id !== undefined && value.id !== null && value.id !== '' ||
      value.value !== undefined && value.value !== null && value.value !== '';
  }

 /**
  * Checks hrn data for completeness. 
  * 
  * @returns true if hrn data 
  */
  private checkHRNData(): boolean {
    const machineModes = this.form.value.hazardTypesData.machineMode.map(mode => mode.value || mode);
    const chrnFields = [
      "Probability of Occurrence",
      "Frequency of Exposition",
      "Degree of Severity",
      "Number of Persons Exposed"
    ];

    const isMachineModeValid = (mode) => {
      return chrnFields.every(field => {
        const fieldValue = this.form.value.chrnTable?.[field]?.[mode];
        return !this.isFieldEmpty(fieldValue);
      });
    };
    const hasInvalidMode = machineModes.some(mode => !isMachineModeValid(mode));
    if (hasInvalidMode) {
      this.toastService.presentToast(
        this.translate.instant('Please select all dropdown values'),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      return false;
    }
    return true;
  }

  handleMeasuresUpdate(updatedMeasures: any[]) {
    this.dynamicMeasures = this.filterMeasuresForSelectedModes(updatedMeasures || []);
    this.hazardInfo = this.hazardInfo || {};
    this.hazardInfo.controlMeasures = this.dynamicMeasures;
    const plrMeasure = this.dynamicMeasures.find(measure =>
      this.normalizeHazardIdentifier(measure?.measure_type_id || measure?.selectedMeasureType?.measure_type_id) === '3'
    );
    if (plrMeasure?.measurePlrObj) {
      this.isIncludeCategoryChecked = plrMeasure.measurePlrObj.isIncludeRecommandedCategory !== false;
      this.hazardInfo.plrObj = this.hazardInfo.plrObj || {};
    }
    if (!this.hasIncompleteMeasure(this.dynamicMeasures) && !this.hasWhitespaceOnlyMeasureNames(this.dynamicMeasures)) {
      this.showMeasureValidationErrors = false;
    }
    this.isNextEnableOnMeasureChange = this.areAllMeasuresComplete(this.dynamicMeasures);
    this.updateHazardStepState();
  }

  private hasWhitespaceOnlyMeasureNames(measures: any[] = this.dynamicMeasures || []): boolean {
    return measures.some(measure => {
      const rawShortName = measure?.short_name;
      return typeof rawShortName === 'string' && rawShortName.length > 0 && !rawShortName.trim().length;
    });
  }

  /**
   * Gets machine modes list
   */
  private getMachineModesList() {
    this.getMachineModesLoading = true;
    let serviceMachineId = this.machineDetails.machine_Id;
    this.backendService
      .getMachineLimitsByServiceMachineId(serviceMachineId, this.appLanguage)
      .subscribe(
        (data: any) => {
          
          this.machineModeList = data.response
            .map((item: any) => ({
              value: item.mode_name,
              label: item.name === 'Not Available' ? this.translate.instant('not_available') : item.name
            }));
          
          this.translatedMachineModeList = this.machineModeList;
          
          this.machineModeLists = this.getHazardMachineModesFromHazardInfo()
          ?.map(mode => {
            const found = this.machineModes?.find(item => item.id === mode.id);
            return found ? { 
                id: mode.id,
                value: found.mode_name, 
                label: found.name 
            } : { 
                id: mode.id,
                value: mode.value, 
                label: mode.value 
            };
          }).filter(mode => mode.value) || []; // Filter out any modes that don't have a value        
          this.updateHazardStepState();
          
              
        });
      }
}